var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _g, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpShort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 230,
    viewBox: "0 0 189 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10752_2775)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10752_2775)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 185,
    height: 226,
    rx: 24,
    fill: "#0E907A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2227 200.982C21.3922 203.408 21.7315 234.806 18 252.625V269.542L233.746 278L237.477 155.861C244.601 118.644 176.982 98.4061 151.315 122.365C124.855 147.064 129.265 197.937 69.2227 200.982Z",
    fill: "#628EB3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3645 206.641C76.7899 203.254 79.3533 197.68 80.3514 190.574C81.4695 182.624 79.3287 173.188 79.3287 173.188C79.3287 173.188 75.3282 182.904 74.0901 190.574C72.9802 197.455 74.0492 203.966 73.6538 206.737L76.3645 206.641Z",
    fill: "url(#paint0_linear_10752_2775)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6832 206.974C69.3069 203.929 67.1062 198.95 66.2526 192.669C65.309 185.725 67.1116 177.596 67.1116 177.596C67.1116 177.596 70.4959 185.967 71.5731 192.669C72.5521 198.751 71.6658 204.567 72.0176 207.062L69.6832 206.974Z",
    fill: "url(#paint1_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3645 206.641C76.7899 203.254 79.3533 197.68 80.3514 190.574C81.4695 182.624 79.3287 173.188 79.3287 173.188C79.3287 173.188 75.3282 182.904 74.0901 190.574C72.9802 197.455 74.0492 203.966 73.6538 206.737L76.3645 206.641Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6832 206.974C69.3069 203.929 67.1062 198.95 66.2526 192.669C65.309 185.725 67.1116 177.596 67.1116 177.596C67.1116 177.596 70.4959 185.967 71.5731 192.669C72.5521 198.751 71.6658 204.567 72.0176 207.062L69.6832 206.974Z",
    fill: "#246266"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2181 206.735C74.2181 202.903 76.0916 196.529 76.2116 188.289C76.3479 178.914 72.9119 167.568 72.9119 167.568C72.9119 167.568 70.0812 179.247 69.8412 188.289C69.6285 196.27 71.5592 203.709 71.5211 206.843L74.2181 206.733V206.735Z",
    fill: "url(#paint2_linear_10752_2775)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4043 206.743C79.1488 203.158 82.2222 197.232 83.913 189.631C85.8192 181.061 84.6329 170.803 84.6329 170.803C84.6329 170.803 79.6779 181.364 77.7008 189.631C75.9418 196.993 76.3781 203.915 75.7264 206.845L78.4043 206.743Z",
    fill: "url(#paint3_linear_10752_2775)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2835 206.755C66.5881 203.608 63.7465 198.455 62.2194 191.935C60.5259 184.7 61.6712 176.199 61.6712 176.199C61.6712 176.199 66.1327 184.953 67.938 191.935C69.5715 198.249 69.176 204.271 69.7896 206.846L67.2835 206.755Z",
    fill: "url(#paint4_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6712 176.199C61.6712 176.199 62.2848 185.682 64.1556 192.29C65.5545 197.234 68.5106 203.914 69.3342 206.799L67.2835 206.755C66.5881 203.608 63.7465 198.455 62.2194 191.935C60.5259 184.7 61.6712 176.199 61.6712 176.199Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6536 206.735C73.4654 204.121 71.8047 195.992 71.9274 187.788C72.0828 177.449 72.9119 167.57 72.9119 167.57C72.9119 167.57 70.0812 179.249 69.8412 188.291C69.6285 196.272 71.5592 203.711 71.5211 206.845L73.6536 206.735Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6735 206.744C78.3962 203.159 78.118 197.137 79.5633 189.522C81.1941 180.938 84.6329 170.801 84.6329 170.801C84.6329 170.801 79.6779 181.362 77.7008 189.629C75.9418 196.991 76.3781 203.913 75.7264 206.843L77.6708 206.741L77.6735 206.744Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7245 182.745C63.0728 182.877 63.7027 186.863 64.7117 190.574C65.6253 193.928 66.847 197.056 67.7197 196.902C69.555 196.574 64.8044 182.527 63.7245 182.745Z",
    fill: "#47B3AA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9103 177.951C83.2749 177.758 81.8895 182.801 81.0496 186.553C80.2915 189.945 79.8688 194.633 80.7114 194.908C81.5186 195.175 82.9394 191.329 83.6403 187.478C84.4748 182.889 84.4829 178.124 83.9103 177.951Z",
    fill: "#47B3AA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5285 174.629C72.5768 174.648 72.3914 192.921 74.4094 192.979C76.4274 193.036 74.7202 174.607 73.5285 174.629Z",
    fill: "#47B3AA"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5843 224.434H76.9127C79.168 220.005 81.0033 214.153 82.3995 206.117H63.0948C64.5947 214.69 66.4163 220.426 68.5816 224.434H68.5843Z",
    fill: "url(#paint5_linear_10752_2775)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3348 207.443C63.253 207.009 63.1739 206.568 63.0948 206.117H82.3995C82.3204 206.566 82.2414 207.009 82.1623 207.443H63.3348Z",
    fill: "#D8CCFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2206 206.117C70.2206 206.117 70.8778 217.254 72.8031 224.434H68.5816C66.4163 220.426 64.5947 214.692 63.0948 206.117H70.2206Z",
    fill: "#60578F"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M176.246 148.62L130.563 194.705L132.021 196.176L177.704 150.091L176.246 148.62Z",
    fill: "url(#paint6_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.963 194.3L174.126 150.757L176.247 148.617L176.801 149.176L177.706 150.089L175.448 152.367C175.185 152.023 174.916 151.689 174.641 151.355L131.563 194.813C131.894 195.091 132.225 195.362 132.566 195.626L132.025 196.172L130.57 194.7L130.97 194.297L130.963 194.3Z",
    fill: "#9E4435"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M150.144 218.016H153.867V202.41H150.144V218.016Z",
    fill: "url(#paint7_linear_10752_2775)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M152.006 198.504C167.472 198.504 180.011 185.855 180.011 170.252C180.011 154.649 167.472 142 152.006 142C136.539 142 124.001 154.649 124.001 170.252C124.001 185.855 136.539 198.504 152.006 198.504Z",
    fill: "url(#paint8_linear_10752_2775)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M154.94 178.671C156.625 177.586 158.982 177.666 160.745 176.538C161.65 175.959 162.502 175.166 163.325 174.511C163.915 174.041 164.512 173.125 165.203 172.646C166.144 171.994 166.659 172.546 167.692 172.345C168.665 172.156 169.114 171.515 170.271 171.624C170.016 171.882 170.229 171.534 170.153 172.034C171.038 172.259 172.199 173.727 172.287 174.507C172.363 175.175 171.756 175.89 171.848 176.65C171.94 177.398 172.402 177.871 172.425 178.664C172.471 180.308 171.583 181.237 170.589 182.315C169.803 183.172 169.35 184.342 168.403 185.077C167.803 185.543 167.036 185.695 166.403 186.112C164.05 187.663 164.004 191.39 162.361 193.414C161.876 194.012 157.742 197.67 156.693 196.595C156.153 196.039 157.208 195.818 157.352 195.328C157.539 194.693 157.31 194.445 157.267 193.88C157.162 192.554 156.369 191.519 156.228 190.269C156.146 189.518 156.841 188.794 156.271 188.122C155.943 187.739 155.363 188.017 154.946 187.821C153.389 187.091 153.635 185.993 153.904 184.481C154.277 182.381 152.75 180.083 154.943 178.671H154.94Z",
    fill: "url(#paint9_radial_10752_2775)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M178.837 170.871C178.145 171.152 177.519 170.725 176.857 171.059C176.362 171.307 176.041 171.939 175.608 171.949C175.375 172.117 175.077 172.177 174.769 172.15C174.215 170.96 175.634 170.328 176.428 169.74C176.995 169.316 177.336 169.502 177.677 168.698C177.965 168.013 177.896 167.114 177.867 166.37C177.791 164.564 176.139 163.718 174.428 164.032C173.713 164.164 173.402 164.67 172.753 163.992C172.163 163.374 172.192 162.362 171.524 161.674C170.173 160.288 169.439 158.717 167.678 157.825C166.816 157.388 165.915 156.928 165.19 156.353C164 155.41 164.908 155.159 164.44 154.064C164.092 153.248 163.259 153.463 162.532 153.281C161.84 153.109 160.637 152.725 160.244 152.08C159.706 151.194 160.224 150.714 160.548 149.954C160.706 149.583 160.427 149.233 160.83 148.968C161.502 148.529 161.588 149.385 162.073 149.388C162.538 149.392 162.709 148.962 163.092 148.965C163.827 148.972 163.879 149.474 164.325 149.937C165.269 150.916 166.613 151.402 167.99 151.247C169.203 151.111 169.967 150.731 168.737 149.802C168.141 149.352 167.898 149.593 167.76 148.747C167.728 148.552 168.029 148.171 167.891 147.794C168.16 147.665 168.465 147.616 168.793 147.629C175.49 152.695 179.863 160.715 180.011 169.776C179.676 170.285 179.286 170.689 178.84 170.871H178.837Z",
    fill: "url(#paint10_radial_10752_2775)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M129.882 157.144C130.347 157.392 130.603 158.176 131.013 158.302C131.308 158.391 133.045 157.769 133.497 157.643C133.953 157.518 134.769 157.359 134.989 156.942C135.425 156.116 134.497 155.474 135.959 155.471C136.484 155.471 137.31 155.729 137.92 155.801C138.605 155.884 139.182 156.089 139.788 156.344C140.309 156.562 140.709 156.843 141.23 156.81C141.253 156.913 141.289 157.008 141.447 156.995C142.302 157.071 143.299 158.146 143.653 158.834C143.951 159.409 143.922 159.899 144.325 160.471C144.64 160.917 145.056 161.248 145.397 161.658C146.387 162.852 146.646 163.89 146.495 165.425C146.384 166.562 147.023 167.882 146.659 168.867C146.387 169.605 145.653 169.856 145.223 170.445C144.856 170.951 144.82 171.639 144.391 172.115C143.437 173.176 142.099 172.809 140.903 172.928C140.454 172.975 139.978 173.319 139.457 173.14C138.9 172.948 138.674 172.204 137.962 172.072C137.336 171.956 137.116 172.356 136.638 172.416C136.133 172.475 135.667 172.217 135.176 172.28C133.773 172.455 134.471 174.38 133.74 175.425C133.406 175.905 132.878 176.202 132.586 176.788C132.18 177.605 132.265 178.269 132.078 179.116C131.963 179.645 131.232 180.22 131.239 180.627C131.249 181.196 131.862 181.203 132.052 181.656C132.34 182.337 132.065 183.382 131.78 184.013C131.383 184.887 131.239 185.369 131.032 186.312C130.944 186.719 130.698 187.717 130.272 188.068C126.354 183.207 124.007 177.009 124.007 170.256C124.007 166.202 124.856 162.343 126.381 158.857C127.302 157.541 128.488 156.4 129.888 157.147L129.882 157.144Z",
    fill: "url(#paint11_radial_10752_2775)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M148.711 142.771C150.219 142.298 151.462 142.761 152.97 143.072C153.655 143.214 156.284 143.055 156.375 144.041C156.779 144.484 155.818 144.375 155.569 144.309C155.169 144.203 154.858 144.077 154.451 144.266C154.425 144.778 154.638 145.363 154.868 145.777C155.199 146.372 155.733 146.587 155.556 147.43C155.428 148.029 154.605 148.254 153.999 148.055C153.51 147.897 153.114 147.262 152.72 146.924C152.265 146.534 151.786 146.319 151.206 146.207C150.445 146.058 149.668 145.949 148.918 145.734C147.987 145.469 147.075 144.854 146.108 144.795C145.672 143.912 148.19 142.933 148.711 142.767V142.771Z",
    fill: "url(#paint12_radial_10752_2775)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.456 154.908C143.568 155.692 143.335 156.135 142.463 156.247C141.791 156.333 141.053 155.937 140.476 155.573C140.004 155.275 139.916 155.077 139.726 154.62C139.493 154.058 139.07 154.111 138.713 153.714C138.352 153.311 138.474 152.944 137.788 152.686C137.228 152.474 136.71 152.53 136.176 152.768C135.205 153.205 133.406 154.2 132.389 153.337C131.842 152.874 132.062 152.206 132.422 151.657C133.189 150.49 134.396 149.117 135.785 148.75C136.572 148.542 137.529 148.598 138.264 148.946C138.87 149.233 139.067 149.921 139.667 150.239C140.349 150.599 141.037 150.374 140.572 151.36C140.44 151.637 140.237 151.766 140.257 152.16C140.27 152.461 140.286 152.712 140.578 152.864C141.371 153.274 142.46 152.577 143.26 153.106V153.112C143.591 153.281 143.558 153.602 143.525 153.916C143.483 154.309 143.397 154.485 143.456 154.908Z",
    fill: "url(#paint13_radial_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M152.006 142C158.008 142 163.568 143.905 168.124 147.146C164.708 145.337 160.821 144.312 156.697 144.312C143.109 144.312 132.094 155.423 132.094 169.131C132.094 182.838 143.109 193.95 156.697 193.95C164.944 193.95 172.242 189.856 176.706 183.576C171.986 192.458 162.696 198.504 152.006 198.504C136.54 198.504 124.001 185.854 124.001 170.252C124.001 154.649 136.54 142 152.006 142Z",
    fill: "#26426A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M151.576 202.406V202.476C151.721 202.476 151.861 202.476 152.006 202.476C152.632 202.476 153.251 202.456 153.868 202.419V205.892C153.251 205.925 152.629 205.945 152.006 205.945C151.861 205.945 151.721 205.945 151.576 205.945V218.015H150.144V205.898V202.426V202.41H151.576V202.406Z",
    fill: "#9E4435"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M128.656 223.358H175.356V220.467C159.598 215.844 144.033 215.844 128.656 220.467V223.358Z",
    fill: "url(#paint14_linear_10752_2775)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M152.006 204.574C170.766 204.574 186.029 189.177 186.029 170.254C186.029 161.074 182.483 152.446 176.041 145.961L173.615 148.418C179.404 154.248 182.594 162.003 182.594 170.254C182.594 187.265 168.875 201.109 152.009 201.109C143.83 201.109 136.143 197.891 130.364 192.051L127.928 194.501C134.356 200.999 142.909 204.578 152.006 204.578V204.574Z",
    fill: "url(#paint15_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M151.825 217.004C148.76 217.936 147.062 220.473 147.062 220.473H175.356V223.363H128.656V220.473C136.33 218.165 144.056 217.007 151.825 217.004Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M182.735 169.098C182.735 170.6 182.627 172.078 182.42 173.523C182.532 172.448 182.591 171.357 182.591 170.253C182.591 161.998 179.404 154.243 173.612 148.416L174.251 147.771C179.725 153.539 182.735 161.082 182.735 169.098Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M128.577 193.845C134.946 200.025 143.289 203.418 152.15 203.418C169.272 203.418 183.482 190.591 185.833 173.963C183.994 191.149 169.524 204.573 152.009 204.573C142.909 204.573 134.36 200.994 127.931 194.496L128.58 193.841L128.577 193.845Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M155.939 149.024C146.203 157.199 167.672 168.43 172.94 164.23C181.112 157.718 164.433 141.894 155.939 149.024Z",
    fill: "#FFF7E6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M172.95 168.55C165.312 168.024 168.003 178.637 171.668 178.782C177.355 179.007 178.935 168.964 172.95 168.55Z",
    fill: "#FFF7E6"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9999 226.967L115.976 226.782L84.3977 195.107L52.9999 226.964V226.967ZM101.365 220.915L67.5744 221.015L84.4207 203.921L101.365 220.915Z",
    fill: "url(#paint16_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5983 200.058L81.736 199.919L80.6902 198.871L80.5526 199.007L81.5983 200.058Z",
    fill: "#463332"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7492 200.922L80.8836 200.783L79.8379 199.734L79.7035 199.87L80.7492 200.922Z",
    fill: "#463332"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8088 202.886L78.9432 202.751L77.8975 201.699L77.7631 201.838L78.8088 202.886Z",
    fill: "#463332"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9561 203.75L78.0937 203.614L77.048 202.562L76.9103 202.701L77.9561 203.75Z",
    fill: "#463332"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0155 205.713L76.1531 205.578L75.1074 204.529L74.973 204.665L76.0155 205.713Z",
    fill: "#463332"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1665 206.576L75.3009 206.441L74.2552 205.393L74.1208 205.528L75.1665 206.576Z",
    fill: "#463332"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M73.226 208.543L73.3604 208.404L72.3179 207.355L72.1802 207.491L73.226 208.543Z",
    fill: "#463332"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3735 209.406L72.5112 209.267L71.4654 208.219L71.3278 208.354L72.3735 209.406Z",
    fill: "#463332"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M70.436 211.371L70.5704 211.235L69.5247 210.184L69.3903 210.322L70.436 211.371Z",
    fill: "#463332"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5838 212.234L69.7182 212.095L68.6725 211.047L68.5381 211.182L69.5838 212.234Z",
    fill: "#463332"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6433 214.199L67.7809 214.063L66.7352 213.012L66.5975 213.151L67.6433 214.199Z",
    fill: "#463332"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7909 215.062L66.9286 214.927L65.8829 213.875L65.7452 214.014L66.7909 215.062Z",
    fill: "#463332"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8305 217.052L64.9649 216.914L63.9191 215.865L63.7847 216.001L64.8305 217.052Z",
    fill: "#463332"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9783 217.916L64.1127 217.777L63.067 216.729L62.9326 216.864L63.9783 217.916Z",
    fill: "#463332"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0275 219.891L62.1619 219.755L61.1162 218.707L60.9818 218.843L62.0275 219.891Z",
    fill: "#463332"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1758 220.754L61.3102 220.618L60.2645 219.566L60.1301 219.705L61.1758 220.754Z",
    fill: "#463332"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1794 222.777L59.3138 222.641L58.2681 221.59L58.1337 221.729L59.1794 222.777Z",
    fill: "#463332"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M58.327 223.64L58.4614 223.505L57.4189 222.453L57.2812 222.592L58.327 223.64Z",
    fill: "#463332"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4305 199.976L83.6141 199.791L81.6898 197.859L81.5062 198.045L83.4305 199.976Z",
    fill: "#463332"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6278 202.817L80.8113 202.632L78.8871 200.697L78.7035 200.886L80.6278 202.817Z",
    fill: "#463332"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8251 205.657L78.0087 205.472L76.0844 203.537L75.9008 203.726L77.8251 205.657Z",
    fill: "#463332"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0224 208.499L75.206 208.314L73.2817 206.379L73.0981 206.567L75.0224 208.499Z",
    fill: "#463332"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2194 211.339L72.403 211.153L70.4787 209.219L70.2952 209.404L72.2194 211.339Z",
    fill: "#463332"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4166 214.178L69.6001 213.993L67.6759 212.059L67.4923 212.244L69.4166 214.178Z",
    fill: "#463332"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6138 217.02L66.7973 216.832L64.8698 214.9L64.6862 215.086L66.6138 217.02Z",
    fill: "#463332"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8111 219.86L63.9947 219.672L62.0671 217.74L61.8835 217.925L63.8111 219.86Z",
    fill: "#463332"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0083 222.699L61.1919 222.513L59.2643 220.582L59.0807 220.767L61.0083 222.699Z",
    fill: "#463332"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2022 225.538L58.3858 225.353L56.4615 223.422L56.2812 223.607L58.2022 225.538Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8473 226.888C80.8473 226.626 80.8473 225.803 80.8408 224.381H82.4372L82.4274 220.971L101.365 220.915L86.9676 206.473C86.925 206.311 86.8692 206.156 86.8659 205.981L86.843 197.865C86.843 197.776 86.8823 197.703 86.8922 197.617L115.972 226.785L80.844 226.888H80.8473Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M101.719 220.573L101.024 220.576L84.4273 203.929L84.7748 203.578L101.719 220.573Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3945 195.111L84.6437 195.359L53.8293 226.624L115.632 226.442L115.973 226.786L52.9999 226.968L84.3945 195.111Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5421 221.499L86.2928 221.443L86.2915 220.99L67.5407 221.046L67.5421 221.499Z",
    fill: "#FFF7E6"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M182.151 225.364L182.966 225.15L182.4 222.955L181.585 223.169L182.151 225.364Z",
    fill: "url(#paint17_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M182.148 225.369L182.563 225.26L181.997 223.064L181.582 223.173L182.148 225.369Z",
    fill: "#463332"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M179.86 226.709L185.531 226.692C185.983 226.692 186.35 226.318 186.35 225.862C186.35 225.406 185.98 225.035 185.528 225.035L179.856 225.052C179.404 225.052 179.037 225.425 179.037 225.882C179.037 226.338 179.407 226.709 179.86 226.709Z",
    fill: "url(#paint18_linear_10752_2775)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M182.04 223.244C182.817 223.039 183.282 222.239 183.079 221.455L182.768 220.245C182.564 219.461 181.771 218.991 180.994 219.197C180.217 219.402 179.752 220.202 179.955 220.986L180.266 222.196C180.47 222.98 181.263 223.449 182.04 223.244Z",
    fill: "url(#paint19_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M180.998 219.196C181.181 219.146 181.365 219.143 181.545 219.166C181.748 219.289 181.971 219.378 182.204 219.444C182.469 219.636 182.682 219.904 182.771 220.248L183.056 221.349C182.719 221.716 182.302 222.017 181.788 222.152C181.548 222.215 181.309 222.232 181.07 222.228C181.394 222.761 182.014 223.055 182.643 222.896C182.473 223.052 182.279 223.184 182.04 223.247C181.263 223.452 180.47 222.979 180.266 222.199L179.955 220.988C179.752 220.205 180.217 219.404 180.994 219.199L180.998 219.196Z",
    fill: "#463332"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M181.627 221.646C183.073 221.265 183.938 219.777 183.561 218.322L168.855 161.27L163.623 162.642L178.329 219.694C178.706 221.153 180.181 222.026 181.624 221.646H181.627Z",
    fill: "url(#paint20_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M163.627 162.642L168.859 161.27L169.416 163.432C168.836 164.438 167.98 165.248 166.957 165.777L180.165 217.012C180.542 218.471 182.017 219.344 183.459 218.964C183.525 218.947 183.584 218.914 183.649 218.894C183.702 220.151 182.886 221.318 181.63 221.646C180.184 222.026 178.709 221.15 178.336 219.694L164.607 166.438L163.63 162.642H163.627Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M179.853 225.055L182.118 225.049C181.666 225.049 181.299 225.423 181.299 225.879C181.299 226.335 181.669 226.706 182.122 226.702L179.857 226.709C179.404 226.709 179.034 226.342 179.034 225.886C179.034 225.429 179.398 225.055 179.85 225.055H179.853Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M179.857 226.146L185.528 226.129C185.882 226.129 186.177 225.898 186.291 225.58C186.324 225.669 186.347 225.762 186.347 225.861C186.347 226.318 185.983 226.691 185.528 226.691L179.857 226.708C179.404 226.708 179.034 226.341 179.034 225.884C179.034 225.785 179.057 225.693 179.089 225.603C179.204 225.921 179.499 226.149 179.857 226.149V226.146Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M185.793 225.408C185.895 225.093 183.971 225.169 183.902 225.335C183.797 225.593 185.705 225.682 185.793 225.408Z",
    fill: "#FFF7E6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M183.659 225.409C183.695 225.18 183.026 225.237 183.003 225.356C182.967 225.541 183.63 225.607 183.659 225.409Z",
    fill: "#FFF7E6"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M144.548 224.342C145.981 224.755 147.472 223.916 147.882 222.47L148.515 220.238C148.924 218.793 148.092 217.288 146.659 216.875C145.227 216.462 143.735 217.302 143.325 218.747L142.693 220.979C142.283 222.424 143.116 223.929 144.548 224.342Z",
    fill: "url(#paint21_linear_10752_2775)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M144.001 226.272C145.053 226.576 146.151 225.957 146.453 224.896L146.918 223.252C147.22 222.191 146.607 221.083 145.554 220.779C144.502 220.474 143.404 221.093 143.102 222.154L142.637 223.798C142.335 224.86 142.948 225.967 144.001 226.272Z",
    fill: "url(#paint22_linear_10752_2775)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M145.118 222.32C146.554 222.734 148.049 221.894 148.459 220.445L164.787 162.712L159.591 161.217L143.263 218.951C142.853 220.399 143.686 221.907 145.121 222.32H145.118Z",
    fill: "url(#paint23_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M143.26 218.951L158.988 163.34L159.588 161.217L164.784 162.712L163.735 166.422C162.683 166.336 161.712 165.976 160.886 165.413L146.099 217.704C145.689 219.152 146.521 220.66 147.957 221.074C148.023 221.093 148.092 221.097 148.157 221.11C147.541 222.129 146.312 222.661 145.118 222.317C143.683 221.904 142.853 220.396 143.263 218.947L143.26 218.951Z",
    fill: "#9E4435"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M162.44 156.392L165.99 156.382L165.967 148.423C165.967 147.434 165.167 146.633 164.187 146.637C163.207 146.637 162.414 147.444 162.417 148.432L162.44 156.392Z",
    fill: "url(#paint24_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M164.187 146.637C164.292 146.637 164.384 146.68 164.485 146.696C163.928 147 163.538 147.576 163.541 148.257L163.551 151.604C163.767 151.574 163.981 151.544 164.203 151.541C164.826 151.541 165.413 151.66 165.98 151.835L165.993 156.211V156.382L162.443 156.392L162.43 151.845L162.42 148.432C162.42 147.444 163.21 146.64 164.19 146.637H164.187Z",
    fill: "#463332"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M168.475 163.118C170.826 160.746 170.826 156.902 168.475 154.531C166.125 152.16 162.314 152.16 159.963 154.531C157.613 156.902 157.613 160.746 159.963 163.118C162.314 165.489 166.125 165.489 168.475 163.118Z",
    fill: "url(#paint25_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M160.981 158.654C160.988 160.559 162.535 162.097 164.443 162.094C166.351 162.087 167.891 160.539 167.885 158.635C167.878 156.73 166.331 155.192 164.423 155.195C162.515 155.202 160.975 156.75 160.981 158.654Z",
    fill: "#9E4435"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M166.509 161.135C167.774 159.859 167.774 157.79 166.509 156.514C165.245 155.238 163.194 155.238 161.929 156.514C160.664 157.79 160.664 159.859 161.929 161.135C163.194 162.411 165.245 162.411 166.509 161.135Z",
    fill: "url(#paint26_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M163.214 152.855C160.837 153.53 159.086 155.713 159.093 158.325C159.103 161.467 161.633 164.003 164.748 163.997C167.337 163.99 169.491 162.211 170.147 159.81C169.681 162.687 167.226 164.89 164.243 164.9C160.919 164.91 158.214 162.198 158.205 158.844C158.195 155.832 160.368 153.345 163.217 152.859L163.214 152.855Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M164.108 156.532C162.896 157.557 165.58 158.95 166.236 158.424C167.252 157.607 165.167 155.639 164.108 156.532Z",
    fill: "#FFF7E6"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M166.236 158.963C165.282 158.9 165.623 160.223 166.079 160.24C166.79 160.266 166.983 159.013 166.236 158.963Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M164.407 147.074C163.571 147.544 164.977 148.635 165.426 148.397C166.124 148.027 165.138 146.664 164.407 147.074Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M164.21 155.557C164.249 155.557 164.286 155.567 164.325 155.567C162.745 155.633 161.486 156.939 161.489 158.549C161.493 160.2 162.823 161.529 164.456 161.526C166.092 161.522 167.41 160.18 167.406 158.533C167.406 158.368 167.383 158.206 167.357 158.047C167.416 158.295 167.459 158.549 167.459 158.814C167.465 160.62 166.016 162.085 164.23 162.091C162.44 162.098 160.988 160.636 160.981 158.834C160.975 157.032 162.424 155.563 164.21 155.557Z",
    fill: "#463332"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M126.679 197.26L156.434 197.174L169.917 226.748L140.732 226.834L126.751 198.268C126.59 197.944 126.58 197.587 126.676 197.263L126.679 197.26Z",
    fill: "url(#paint27_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M126.679 197.26L156.434 197.174L169.917 226.748L140.732 226.834L126.751 198.268C126.59 197.944 126.58 197.587 126.676 197.263L126.679 197.26Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M127.672 200.14L126.754 198.265C126.594 197.941 126.584 197.584 126.679 197.26L156.435 197.174L157.746 200.051L127.672 200.14Z",
    fill: "#60578F"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M156.434 197.173L126.679 197.259C126.784 196.906 127.02 196.595 127.374 196.419L132.462 193.886C132.54 193.847 132.875 193.754 132.957 193.754C132.986 193.754 133.012 193.754 133.042 193.754L162.381 193.668L162.397 199.174L157.356 199.187L156.438 197.173H156.434Z",
    fill: "url(#paint28_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M156.434 197.173L126.679 197.259C126.784 196.906 127.02 196.595 127.374 196.419L132.462 193.886C132.766 193.734 132.953 193.754 133.042 193.754L162.381 193.668L156.434 197.173Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M150.367 196.353L155.454 193.819C155.759 193.667 155.946 193.687 156.034 193.687L158.824 193.681C158.739 193.681 158.549 193.661 158.244 193.813L153.156 196.346C152.802 196.521 152.566 196.835 152.461 197.186L149.672 197.193C149.776 196.839 150.012 196.528 150.367 196.353Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M129.823 196.413L134.91 193.88C135.215 193.728 135.402 193.748 135.491 193.748L138.28 193.741C138.195 193.741 138.005 193.721 137.7 193.873L132.612 196.407C132.258 196.582 132.022 196.896 131.917 197.247L129.128 197.253C129.233 196.899 129.469 196.588 129.823 196.413Z",
    fill: "#60578F"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M170.881 225.204L175.654 222.827L176.074 223.68C176.988 223.223 177.457 222.992 177.457 222.992L163.476 194.426C163.141 193.745 162.322 193.464 161.647 193.801L156.559 196.334C155.884 196.671 155.605 197.498 155.939 198.179L169.921 226.745C169.921 226.745 170.393 226.511 171.301 226.058L170.881 225.204Z",
    fill: "url(#paint29_linear_10752_2775)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M162.913 196.773L175.665 222.825L170.892 225.203L158.14 199.151C157.928 198.718 158.104 198.195 158.533 197.982L161.754 196.377C162.183 196.163 162.701 196.34 162.913 196.773Z",
    fill: "#CEB6AA"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M162.89 196.737L158.117 199.115L170.882 225.194L175.655 222.816L162.89 196.737Z",
    fill: "#CEB6AA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M161.689 196.288L158.49 197.882C158.054 198.097 157.877 198.63 158.093 199.066L170.885 225.202L175.657 222.824L162.866 196.689C162.653 196.249 162.125 196.07 161.693 196.288H161.689Z",
    fill: "#FFE6D6"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M162.24 198.553C162.024 198.113 161.499 197.935 161.063 198.15L158.313 199.519L158.09 199.062C157.877 198.622 158.054 198.093 158.486 197.878L161.686 196.284C162.122 196.069 162.646 196.248 162.859 196.685L175.651 222.82L174.415 223.435L162.237 198.55L162.24 198.553Z",
    fill: "#CEB6AA"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M160.102 198.547C160.102 198.547 160.765 199.972 161.761 202.109C162.781 204.235 164.141 207.066 165.501 209.9C166.905 212.711 168.308 215.525 169.36 217.632C170.438 219.728 171.156 221.124 171.156 221.124C171.156 221.124 170.494 219.698 169.498 217.562C168.478 215.436 167.118 212.605 165.757 209.771C164.354 206.96 162.951 204.149 161.899 202.039C160.82 199.942 160.102 198.547 160.102 198.547Z",
    fill: "#CEB6AA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M170.176 216.256C170.176 216.256 170.343 216.689 170.612 217.327C170.881 217.966 171.274 218.802 171.671 219.636C172.087 220.462 172.503 221.286 172.844 221.891C173.182 222.496 173.425 222.893 173.425 222.893C173.425 222.893 173.261 222.46 172.989 221.822C172.72 221.183 172.326 220.347 171.927 219.513C171.51 218.687 171.094 217.863 170.753 217.261C170.415 216.656 170.173 216.259 170.173 216.259L170.176 216.256Z",
    fill: "#CEB6AA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M160.345 201.561C160.345 201.561 160.843 202.649 161.588 204.282C162.342 205.913 163.381 208.065 164.423 210.222C165.485 212.368 166.547 214.511 167.37 216.105C168.203 217.695 168.757 218.757 168.757 218.757C168.757 218.757 168.259 217.669 167.514 216.035C166.76 214.405 165.721 212.252 164.679 210.096C163.617 207.95 162.555 205.807 161.729 204.213C160.896 202.622 160.342 201.561 160.342 201.561H160.345Z",
    fill: "#CEB6AA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M152.062 205.54L152.039 197.924H153.379C153.376 196.462 153.373 195.715 153.373 195.715L91.7671 195.893C90.6985 195.893 89.833 196.773 89.8363 197.854L89.8593 205.97C89.8593 207.048 90.7312 207.921 91.8032 207.918L153.409 207.739C153.409 207.739 153.409 206.988 153.402 205.537H152.062V205.54Z",
    fill: "url(#paint30_linear_10752_2775)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M152.061 205.539L94.396 205.707C93.7174 205.707 93.1667 205.158 93.1667 204.474L93.1536 199.335C93.1536 198.65 93.6977 198.094 94.3763 198.094L152.042 197.926L152.065 205.542L152.061 205.539Z",
    fill: "#CEB6AA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M152.045 197.916L121.205 198.008L121.227 205.624L152.068 205.532L152.045 197.916Z",
    fill: "#CEB6AA"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M152.045 197.916L121.205 198.008L121.227 205.624L152.068 205.532L152.045 197.916Z",
    fill: "#FFE6D6"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M122.752 202.721C122.752 202.721 124.273 202.764 126.554 202.823C128.836 202.873 131.878 202.883 134.92 202.889C137.962 202.866 141.004 202.84 143.286 202.777C145.567 202.701 147.088 202.651 147.088 202.651C147.088 202.651 145.567 202.608 143.286 202.549C141.004 202.499 137.962 202.489 134.92 202.482C131.878 202.506 128.836 202.535 126.554 202.595C124.273 202.671 122.752 202.721 122.752 202.721Z",
    fill: "#CEB6AA"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M140.329 200.865C140.329 200.865 140.978 200.921 141.955 200.974C142.932 201.027 144.23 201.043 145.531 201.053C146.833 201.037 148.131 201.014 149.108 200.954C150.085 200.901 150.734 200.835 150.734 200.835C150.734 200.835 150.085 200.772 149.108 200.726C148.131 200.673 146.833 200.656 145.531 200.646C144.23 200.663 142.932 200.689 141.955 200.746C140.981 200.805 140.329 200.865 140.329 200.865Z",
    fill: "#CEB6AA"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M126.705 204.286C126.705 204.286 127.698 204.342 129.19 204.392C130.681 204.445 132.668 204.458 134.655 204.465C136.641 204.445 138.628 204.418 140.116 204.359C141.604 204.306 142.597 204.237 142.597 204.237C142.597 204.237 141.604 204.174 140.113 204.127C138.621 204.075 136.635 204.061 134.648 204.055C132.661 204.075 130.675 204.101 129.187 204.161C127.698 204.22 126.705 204.283 126.705 204.283V204.286Z",
    fill: "#CEB6AA"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M152.042 197.919L121.201 198.012L121.207 199.741L152.047 199.649L152.042 197.919Z",
    fill: "#CEB6AA"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7671 195.897L119.903 195.814L119.939 207.839L91.8032 207.921C90.7345 207.921 89.8625 207.052 89.8593 205.974L89.8363 197.858C89.8363 196.78 90.6984 195.9 91.7671 195.897Z",
    fill: "url(#paint31_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7671 195.897L119.657 195.814C118.589 195.814 117.723 196.694 117.727 197.776L117.75 205.891C117.75 206.969 118.622 207.842 119.693 207.839L91.8032 207.921C90.7345 207.921 89.8625 207.052 89.8593 205.974L89.8363 197.858C89.8363 196.78 90.6984 195.9 91.7671 195.897Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M111.154 205.911L111.131 197.796C111.131 196.718 111.993 195.838 113.062 195.835L114.966 195.828C113.897 195.828 113.032 196.708 113.035 197.789L113.058 205.905C113.058 206.983 113.93 207.856 115.002 207.852L113.098 207.859C112.029 207.859 111.157 206.989 111.154 205.911Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9897 205.962L92.9668 197.847C92.9668 196.768 93.8289 195.889 94.8976 195.886L96.8022 195.879C95.7335 195.879 94.8681 196.759 94.8714 197.84L94.8943 205.955C94.8943 207.033 95.7663 207.906 96.8383 207.903L94.9337 207.91C93.865 207.91 92.993 207.04 92.9897 205.962Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M117.75 205.625V205.89C117.753 206.968 118.622 207.841 119.694 207.837L91.8032 207.92C90.7346 207.92 89.8626 207.05 89.8593 205.972V205.708L117.75 205.625Z",
    fill: "#398191"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M149.554 194.354L149.54 189.685H150.363C150.363 188.788 150.36 188.332 150.36 188.332L93.9927 188.497C93.3371 188.497 92.806 189.036 92.8093 189.698L92.8224 194.675C92.8224 195.336 93.3567 195.872 94.0124 195.869L150.38 195.703C150.38 195.703 150.38 195.244 150.376 194.351H149.554V194.354Z",
    fill: "url(#paint32_linear_10752_2775)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5919 189.836L149.546 189.674L149.56 194.344L95.6056 194.505C95.1893 194.506 94.8539 194.167 94.8527 193.75L94.8434 190.599C94.8422 190.179 95.1788 189.84 95.5919 189.839L95.5919 189.836Z",
    fill: "#CEB6AA"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M149.543 189.677L123.852 189.754L123.866 194.423L149.557 194.346L149.543 189.677Z",
    fill: "#CEB6AA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M149.543 189.677L123.852 189.754L123.866 194.423L149.557 194.346L149.543 189.677Z",
    fill: "#FFE6D6"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M124.801 192.644C124.801 192.644 126.158 192.667 128.19 192.7C130.226 192.71 132.937 192.723 135.651 192.736C138.366 192.707 141.077 192.68 143.112 192.657C145.148 192.611 146.502 192.581 146.502 192.581C146.502 192.581 145.145 192.558 143.112 192.525C141.077 192.515 138.366 192.502 135.651 192.488C132.937 192.518 130.226 192.545 128.19 192.568C126.155 192.614 124.801 192.644 124.801 192.644Z",
    fill: "#CEB6AA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M142.361 191.487C142.361 191.487 142.761 191.526 143.358 191.549C143.955 191.563 144.754 191.583 145.551 191.602C147.147 191.609 148.741 191.467 148.741 191.467C148.741 191.467 147.144 191.335 145.551 191.351C144.754 191.374 143.958 191.397 143.358 191.414C142.761 191.444 142.361 191.483 142.361 191.483V191.487Z",
    fill: "#CEB6AA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M127.226 193.607C127.226 193.607 128.259 193.631 129.81 193.667C131.36 193.677 133.425 193.693 135.491 193.707C139.621 193.707 143.755 193.558 143.755 193.558C143.755 193.558 139.624 193.435 135.491 193.455C133.425 193.482 131.36 193.508 129.81 193.528C128.259 193.574 127.226 193.604 127.226 193.604V193.607Z",
    fill: "#CEB6AA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M149.543 189.677L123.852 189.754L123.855 190.812L149.546 190.735L149.543 189.677Z",
    fill: "#CEB6AA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9894 188.498L123.053 188.412L123.073 195.783L94.0091 195.869C93.3535 195.869 92.8191 195.337 92.8191 194.676L92.806 189.699C92.806 189.037 93.3338 188.498 93.9894 188.498Z",
    fill: "url(#paint33_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9894 188.497L122.902 188.414C122.247 188.414 121.716 188.953 121.719 189.615L121.732 194.592C121.732 195.253 122.267 195.789 122.922 195.785L94.0091 195.868C93.3535 195.868 92.8191 195.336 92.8191 194.674L92.806 189.697C92.806 189.036 93.3338 188.497 93.9894 188.497Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M117.69 194.603L117.677 189.626C117.677 188.965 118.205 188.426 118.861 188.426H120.028C119.372 188.426 118.841 188.962 118.844 189.623L118.857 194.6C118.857 195.261 119.392 195.797 120.047 195.794H118.88C118.225 195.8 117.69 195.265 117.69 194.603Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M114.527 194.611L114.514 189.634C114.514 188.973 115.042 188.434 115.697 188.434H116.864C116.209 188.434 115.678 188.969 115.681 189.631L115.694 194.608C115.694 195.269 116.228 195.805 116.884 195.802H115.717C115.061 195.808 114.527 195.272 114.527 194.611Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M98.251 194.658L98.2379 189.681C98.2379 189.02 98.7657 188.48 99.4213 188.48H100.588C99.9327 188.48 99.4016 189.016 99.4049 189.678L99.418 194.655C99.418 195.316 99.9524 195.852 100.608 195.848H99.441C98.7854 195.855 98.251 195.319 98.251 194.658Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0877 194.668L95.0746 189.691C95.0746 189.029 95.6024 188.49 96.258 188.49H97.425C96.7694 188.49 96.2383 189.026 96.2416 189.687L96.2547 194.664C96.2547 195.326 96.789 195.862 97.4447 195.858H96.2777C95.622 195.865 95.0877 195.329 95.0877 194.668Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M121.735 194.427V194.589C121.735 195.251 122.27 195.786 122.925 195.783L94.0123 195.866C93.3567 195.866 92.8224 195.333 92.8224 194.672V194.51L121.735 194.424V194.427Z",
    fill: "#9E4435"
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4302 224.369L85.3908 210.39H83.7944C83.7878 208.657 83.7878 207.768 83.7878 207.768L157.185 207.553C158.46 207.549 159.496 208.588 159.499 209.874L159.542 224.448C159.545 225.735 158.516 226.78 157.241 226.783L83.8436 226.998C83.8436 226.998 83.8436 226.102 83.837 224.372H85.4335L85.4302 224.369Z",
    fill: "url(#paint34_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M156.083 224.163L87.3802 224.368L87.3391 210.39L156.042 210.184C156.848 210.182 157.506 210.841 157.508 211.654L157.541 222.683C157.543 223.497 156.889 224.16 156.083 224.163Z",
    fill: "#A0335D"
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4303 224.368L154.133 224.166C154.94 224.166 155.592 223.502 155.592 222.688L155.559 211.659C155.559 210.846 154.9 210.188 154.094 210.188L85.3909 210.389L85.4303 224.368Z",
    fill: "#FFE6D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7913 210.397C83.7848 208.658 83.7848 207.771 83.7848 207.771L121.237 207.662L121.293 226.892L83.8405 227.001C83.8405 227.001 83.8405 226.105 83.834 224.376H85.4304L85.3911 210.394H83.7946L83.7913 210.397Z",
    fill: "#A0335D"
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M122.136 210.277L85.3951 210.387L85.4363 224.365L122.177 224.255L122.136 210.277Z",
    fill: "#CEB6AA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M122.136 210.277L85.3951 210.387L85.4363 224.365L122.177 224.255L122.136 210.277Z",
    fill: "#CEB6AA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M120.89 210.287L154.094 210.191C154.9 210.191 155.556 210.846 155.559 211.663L155.566 213.753C155.566 212.94 154.907 212.281 154.101 212.281L120.896 212.377L120.89 210.287Z",
    fill: "#CEB6AA"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M153.088 214.134C153.088 214.134 152.117 214.045 150.665 213.982C149.938 213.959 149.092 213.909 148.184 213.903C147.276 213.893 146.305 213.883 145.338 213.873C144.368 213.89 143.401 213.903 142.493 213.919C141.585 213.933 140.736 213.989 140.011 214.015C138.559 214.088 137.589 214.184 137.589 214.184C137.589 214.184 138.559 214.273 140.011 214.339C140.739 214.359 141.585 214.412 142.493 214.419C143.401 214.429 144.371 214.439 145.338 214.448C146.309 214.432 147.276 214.415 148.184 214.402C149.092 214.389 149.941 214.333 150.665 214.306C152.117 214.234 153.088 214.138 153.088 214.138V214.134Z",
    fill: "#CEB6AA"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M148.495 221.691C148.495 221.691 147.075 221.611 144.945 221.542C143.879 221.519 142.637 221.492 141.306 221.466C139.975 221.456 138.556 221.449 137.136 221.439C135.717 221.456 134.297 221.473 132.966 221.489C131.635 221.502 130.393 221.562 129.328 221.588C127.197 221.671 125.777 221.76 125.777 221.76C125.777 221.76 127.197 221.84 129.328 221.912C130.393 221.932 131.635 221.982 132.966 221.988C134.297 221.995 135.717 222.005 137.136 222.015C138.556 221.998 139.975 221.982 141.306 221.965C142.637 221.929 143.879 221.896 144.945 221.866C147.075 221.783 148.495 221.694 148.495 221.694V221.691Z",
    fill: "#CEB6AA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M150.793 216.744C150.793 216.744 149.373 216.664 147.242 216.595C146.177 216.572 144.935 216.545 143.604 216.519C142.273 216.509 140.853 216.502 139.434 216.492C138.014 216.509 136.595 216.525 135.264 216.542C133.933 216.555 132.691 216.615 131.625 216.641C129.495 216.724 128.075 216.813 128.075 216.813C128.075 216.813 129.495 216.892 131.625 216.965C132.691 216.985 133.933 217.035 135.264 217.041C136.595 217.048 138.014 217.058 139.434 217.068C140.853 217.051 142.273 217.035 143.604 217.018C144.935 216.982 146.177 216.949 147.242 216.919C149.373 216.836 150.793 216.747 150.793 216.747V216.744Z",
    fill: "#CEB6AA"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M120.326 219.846C120.326 219.846 118.513 219.746 115.796 219.677C114.435 219.65 112.852 219.624 111.154 219.591C109.456 219.581 107.643 219.574 105.83 219.564C104.017 219.584 102.208 219.604 100.506 219.624C98.8083 219.641 97.2217 219.707 95.8646 219.736C93.147 219.822 91.3342 219.932 91.3342 219.932C91.3342 219.932 93.147 220.031 95.8646 220.1C97.225 220.123 98.8083 220.18 100.506 220.186C102.204 220.196 104.017 220.203 105.83 220.213C107.643 220.193 109.452 220.173 111.154 220.153C112.852 220.113 114.438 220.074 115.796 220.041C118.513 219.955 120.326 219.846 120.326 219.846Z",
    fill: "#B29B93"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3623 213.813C99.3623 213.813 98.5887 213.747 97.425 213.7C96.2612 213.648 94.714 213.631 93.1634 213.621C91.6129 213.641 90.0656 213.664 88.9018 213.727C87.7414 213.78 86.9645 213.853 86.9645 213.853C86.9645 213.853 87.7381 213.919 88.9018 213.965C90.0656 214.018 91.6129 214.034 93.1634 214.044C94.714 214.025 96.2612 214.001 97.425 213.939C98.5854 213.886 99.3623 213.813 99.3623 213.813Z",
    fill: "#B29B93"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M114.54 222.289C114.54 222.289 113.357 222.21 111.58 222.151C109.803 222.084 107.436 222.065 105.073 222.055C102.706 222.078 100.339 222.111 98.5658 222.187C96.7924 222.256 95.6089 222.342 95.6089 222.342C95.6089 222.342 96.7923 222.422 98.5691 222.481C100.346 222.547 102.713 222.564 105.076 222.577C107.443 222.551 109.81 222.521 111.583 222.445C113.357 222.375 114.54 222.289 114.54 222.289Z",
    fill: "#B29B93"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M113.98 216.252C113.98 216.252 112.796 216.173 111.02 216.113C109.243 216.047 106.876 216.027 104.513 216.018C102.146 216.041 99.779 216.074 98.0055 216.15C96.232 216.219 95.0486 216.305 95.0486 216.305C95.0486 216.305 96.232 216.385 98.0088 216.444C99.7855 216.51 102.152 216.527 104.516 216.54C106.883 216.514 109.249 216.484 111.023 216.408C112.796 216.338 113.98 216.252 113.98 216.252Z",
    fill: "#B29B93"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M122.136 210.277L85.3951 210.387L85.4012 212.447L122.142 212.337L122.136 210.277Z",
    fill: "#B29B93"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M146.849 212.44C145.908 214.642 145.607 221.008 145.564 224.249H161.689C161.716 221.104 161.476 214.533 160.48 212.165C159.08 208.832 155.54 206.735 155.54 205.931C155.54 205.128 158.375 203.216 159.929 200.336C161.214 197.958 161.666 193.289 161.693 189.74H145.567C145.541 193.318 145.987 197.981 147.157 200.415C148.478 203.16 151.717 204.979 151.717 205.935C151.717 206.89 148.278 209.103 146.849 212.44ZM146.492 223.333C146.587 219.229 146.987 214.44 147.685 212.803C148.449 211.011 149.908 209.51 150.97 208.415C152.002 207.347 152.629 206.705 152.629 205.935C152.629 205.111 151.934 204.46 150.878 203.478C149.878 202.548 148.636 201.388 147.977 200.015C146.993 197.971 146.531 194.003 146.482 190.66H160.768C160.676 193.977 160.211 197.905 159.132 199.899C158.326 201.394 157.146 202.611 156.198 203.59C155.222 204.599 154.635 205.207 154.635 205.935C154.635 206.662 155.185 207.162 156.185 208.111C157.316 209.185 158.867 210.657 159.65 212.522C160.46 214.454 160.765 219.824 160.788 223.333H146.498H146.492Z",
    fill: "url(#paint35_linear_10752_2775)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M160.781 223.333C160.758 219.821 160.453 214.451 159.644 212.523C158.86 210.658 157.313 209.186 156.179 208.111C155.179 207.162 154.628 206.64 154.628 205.935C154.628 205.231 155.218 204.599 156.192 203.591C157.139 202.612 158.319 201.395 159.126 199.9C160.204 197.903 160.673 193.977 160.762 190.66H146.475C146.525 194.004 146.987 197.972 147.97 200.016C148.629 201.388 149.872 202.549 150.871 203.481C151.927 204.464 152.622 205.115 152.622 205.939C152.622 206.762 151.996 207.354 150.963 208.419C149.901 209.513 148.442 211.015 147.679 212.807C146.98 214.444 146.58 219.233 146.485 223.337H160.775L160.781 223.333Z",
    fill: "url(#paint36_linear_10752_2775)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M145.495 226.998H161.761C162.08 226.998 162.338 226.737 162.338 226.416V223.913C162.338 223.591 162.08 223.331 161.761 223.331H145.495C145.177 223.331 144.918 223.591 144.918 223.913V226.416C144.918 226.737 145.177 226.998 145.495 226.998Z",
    fill: "url(#paint37_linear_10752_2775)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M145.495 190.68H161.761C162.08 190.68 162.338 190.419 162.338 190.098V187.594C162.338 187.273 162.08 187.012 161.761 187.012H145.495C145.177 187.012 144.918 187.273 144.918 187.594V190.098C144.918 190.419 145.177 190.68 145.495 190.68Z",
    fill: "url(#paint38_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M145.469 223.334H151.763V223.985C151.763 224.323 152.009 224.594 152.314 224.594H162.338V226.39C162.338 226.727 162.092 226.998 161.787 226.998H145.469C145.164 226.998 144.918 226.724 144.918 226.39V223.942C144.918 223.605 145.164 223.334 145.469 223.334Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M145.469 187.012H161.787C162.092 187.012 162.338 187.286 162.338 187.62V189.38H152.314C152.009 189.38 151.763 189.654 151.763 189.988V190.676H145.469C145.164 190.676 144.918 190.401 144.918 190.067V187.62C144.918 187.283 145.164 187.012 145.469 187.012Z",
    fill: "#463332"
  }))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M144.522 226.998H162.735C162.974 226.998 163.168 226.803 163.168 226.562V225.559C163.168 225.318 162.974 225.123 162.735 225.123H144.522C144.283 225.123 144.089 225.318 144.089 225.559V226.562C144.089 226.803 144.283 226.998 144.522 226.998Z",
    fill: "url(#paint39_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M144.502 225.125H151.347C151.117 225.125 150.934 225.33 150.934 225.581V226.544C150.934 226.795 151.117 227 151.347 227H144.502C144.273 227 144.089 226.795 144.089 226.544V225.581C144.089 225.33 144.273 225.125 144.502 225.125Z",
    fill: "#463332"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M144.522 188.887H162.735C162.974 188.887 163.168 188.691 163.168 188.45V187.448C163.168 187.207 162.974 187.012 162.735 187.012H144.522C144.283 187.012 144.089 187.207 144.089 187.448V188.45C144.089 188.691 144.283 188.887 144.522 188.887Z",
    fill: "url(#paint40_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M151.717 205.931C151.717 204.975 148.478 203.156 147.157 200.411C145.984 197.977 145.538 193.315 145.567 189.736H161.692C161.686 190.487 161.663 191.287 161.614 192.104H151.583C151.583 192.104 151.081 198.077 152.265 201.651C153.1 204.175 153.553 205.107 153.553 206.235C153.553 207.363 150.976 209.069 151.291 224.245H145.567C145.607 221.004 145.908 214.638 146.852 212.436C148.278 209.096 151.72 206.883 151.72 205.931H151.717Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M144.502 187.012H151.347C151.117 187.012 150.934 187.217 150.934 187.468V188.43C150.934 188.682 151.117 188.887 151.347 188.887H144.502C144.273 188.887 144.089 188.682 144.089 188.43V187.468C144.089 187.217 144.273 187.012 144.502 187.012Z",
    fill: "#463332"
  }))), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M150.875 203.477C149.875 202.548 148.633 201.387 147.974 200.015C147.564 199.162 147.246 197.958 147.01 196.615H160.162C159.909 197.918 159.572 199.076 159.129 199.899C158.323 201.394 157.143 202.611 156.195 203.59C155.218 204.598 154.422 205.359 154.078 205.875C153.642 206.526 153.51 206.467 153.133 205.875C152.812 205.369 151.927 204.463 150.875 203.481V203.477Z",
    fill: "url(#paint41_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M147.154 197.339C147.105 197.101 147.056 196.863 147.01 196.615H160.162C160.113 196.863 160.06 197.105 160.004 197.339H147.154Z",
    fill: "#FFE675"
  }))), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M160.627 218.919C160.67 219.739 160.774 222.028 160.781 223.334H146.492C146.524 221.889 146.613 220.05 146.708 218.919C149.881 218.879 151.812 216.932 153.572 216.932C155.333 216.932 157.66 218.936 160.627 218.919Z",
    fill: "url(#paint42_linear_10752_2775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M153.311 217.398C151.557 217.398 149.088 219.306 146.705 218.919C149.537 218.982 151.809 216.932 153.57 216.932C155.33 216.932 157.657 218.936 160.624 218.919C160.631 219.055 160.641 219.24 160.65 219.442C157.572 219.402 155.146 217.395 153.311 217.395V217.398Z",
    fill: "#FFE675"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M149 196.615C149.173 197.339 149.373 197.988 149.619 198.494C152.038 203.524 156.307 204.403 159.549 198.391C159.736 198.044 159.899 197.627 160.047 197.168C159.811 198.239 159.513 199.195 159.132 199.899C158.326 201.394 157.146 202.611 156.198 203.59C155.222 204.598 154.425 205.359 154.081 205.875C153.645 206.526 153.514 206.467 153.137 205.875C152.815 205.369 151.934 204.463 150.878 203.481C149.878 202.551 148.636 201.391 147.977 200.018C147.567 199.165 147.249 197.961 147.013 196.619H149.003L149 196.615Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M146.705 218.918C149.472 218.931 151.56 217.172 153.232 216.957C152.301 217.337 151.694 217.853 151.694 218.551C151.694 219.993 153.956 220.74 156.33 220.74C158.962 220.74 160.516 219.781 160.598 218.895C160.608 218.895 160.614 218.895 160.624 218.895C160.667 219.722 160.771 222.02 160.778 223.33H146.489C146.521 221.878 146.63 220.003 146.705 218.915V218.918Z",
    fill: "#AA2424"
  }))), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M153.628 208.223C153.864 208.223 154.054 208.031 154.054 207.793C154.054 207.556 153.864 207.363 153.628 207.363C153.393 207.363 153.202 207.556 153.202 207.793C153.202 208.031 153.393 208.223 153.628 208.223Z",
    fill: "#ED9C47"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M153.488 216.247C153.723 216.247 153.914 216.054 153.914 215.817C153.914 215.579 153.723 215.387 153.488 215.387C153.252 215.387 153.062 215.579 153.062 215.817C153.062 216.054 153.252 216.247 153.488 216.247Z",
    fill: "#ED9C47"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M152.871 210.832C152.871 211 153.005 211.136 153.173 211.136C153.34 211.136 153.474 211 153.474 210.832C153.474 210.663 153.34 210.527 153.173 210.527C153.005 210.527 152.871 210.663 152.871 210.832Z",
    fill: "#ED9C47"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M154.11 209.256C154.11 209.381 154.212 209.484 154.336 209.484C154.461 209.484 154.563 209.381 154.563 209.256C154.563 209.13 154.461 209.027 154.336 209.027C154.212 209.027 154.11 209.13 154.11 209.256Z",
    fill: "#ED9C47"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M153.428 214.669C153.553 214.669 153.655 214.567 153.655 214.441C153.655 214.315 153.553 214.213 153.428 214.213C153.303 214.213 153.202 214.315 153.202 214.441C153.202 214.567 153.303 214.669 153.428 214.669Z",
    fill: "#ED9C47"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M152.491 216.56C152.491 216.686 152.592 216.788 152.717 216.788C152.842 216.788 152.943 216.686 152.943 216.56C152.943 216.435 152.842 216.332 152.717 216.332C152.592 216.332 152.491 216.435 152.491 216.56Z",
    fill: "#ED9C47"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M154.31 216.701C154.31 216.827 154.412 216.929 154.536 216.929C154.661 216.929 154.763 216.827 154.763 216.701C154.763 216.575 154.661 216.473 154.536 216.473C154.412 216.473 154.31 216.575 154.31 216.701Z",
    fill: "#ED9C47"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M153.002 208.769C153.127 208.769 153.228 208.667 153.228 208.541C153.228 208.415 153.127 208.312 153.002 208.312C152.877 208.312 152.776 208.415 152.776 208.541C152.776 208.667 152.877 208.769 153.002 208.769Z",
    fill: "#ED9C47"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M153.373 211.662C153.373 211.787 153.474 211.89 153.599 211.89C153.724 211.89 153.825 211.787 153.825 211.662C153.825 211.536 153.724 211.434 153.599 211.434C153.474 211.434 153.373 211.536 153.373 211.662Z",
    fill: "#ED9C47"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M153.602 207.367C153.425 207.407 153.294 207.562 153.294 207.754C153.294 207.972 153.471 208.151 153.687 208.151C153.835 208.151 153.966 208.068 154.031 207.946C153.972 208.111 153.815 208.227 153.631 208.227C153.395 208.227 153.205 208.035 153.205 207.797C153.205 207.569 153.382 207.384 153.605 207.367H153.602Z",
    fill: "#AA2424"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M153.34 215.414C153.235 215.484 153.166 215.606 153.166 215.741C153.166 215.96 153.343 216.138 153.559 216.138C153.7 216.138 153.821 216.066 153.89 215.953C153.835 216.125 153.674 216.247 153.487 216.247C153.251 216.247 153.061 216.056 153.061 215.818C153.061 215.632 153.179 215.474 153.343 215.414H153.34Z",
    fill: "#AA2424"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M153.117 210.531C153.018 210.574 152.95 210.673 152.95 210.786C152.95 210.941 153.074 211.067 153.228 211.067C153.317 211.067 153.395 211.024 153.445 210.961C153.395 211.064 153.294 211.136 153.172 211.136C153.005 211.136 152.871 211.001 152.871 210.832C152.871 210.683 152.976 210.561 153.117 210.535V210.531Z",
    fill: "#AA2424"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M154.304 209.031C154.232 209.064 154.182 209.137 154.182 209.223C154.182 209.339 154.277 209.435 154.392 209.435C154.448 209.435 154.494 209.415 154.533 209.378C154.494 209.445 154.422 209.488 154.34 209.488C154.215 209.488 154.114 209.385 154.114 209.259C154.114 209.144 154.195 209.051 154.304 209.035V209.031Z",
    fill: "#AA2424"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M153.35 214.227C153.297 214.266 153.264 214.326 153.264 214.395C153.264 214.511 153.359 214.607 153.474 214.607C153.543 214.607 153.602 214.574 153.641 214.521C153.609 214.607 153.527 214.67 153.428 214.67C153.304 214.67 153.202 214.567 153.202 214.442C153.202 214.342 153.264 214.26 153.35 214.227Z",
    fill: "#AA2424"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M152.638 216.346C152.596 216.385 152.569 216.438 152.569 216.501C152.569 216.617 152.664 216.713 152.779 216.713C152.838 216.713 152.894 216.686 152.93 216.647C152.897 216.729 152.815 216.789 152.72 216.789C152.596 216.789 152.494 216.686 152.494 216.561C152.494 216.465 152.553 216.382 152.638 216.349V216.346Z",
    fill: "#AA2424"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M154.428 216.504C154.392 216.54 154.369 216.593 154.369 216.649C154.369 216.765 154.464 216.861 154.579 216.861C154.654 216.861 154.72 216.821 154.756 216.759C154.73 216.858 154.641 216.934 154.536 216.934C154.412 216.934 154.31 216.831 154.31 216.706C154.31 216.62 154.359 216.544 154.428 216.504Z",
    fill: "#AA2424"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M152.963 208.316C152.894 208.349 152.848 208.422 152.848 208.505C152.848 208.621 152.943 208.717 153.058 208.717C153.113 208.717 153.163 208.693 153.199 208.66C153.159 208.726 153.087 208.773 153.005 208.773C152.881 208.773 152.779 208.67 152.779 208.545C152.779 208.432 152.861 208.34 152.966 208.32L152.963 208.316Z",
    fill: "#AA2424"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M153.481 211.469C153.451 211.505 153.432 211.551 153.432 211.604C153.432 211.72 153.527 211.816 153.642 211.816C153.72 211.816 153.786 211.773 153.822 211.71C153.802 211.816 153.71 211.895 153.599 211.895C153.474 211.895 153.373 211.793 153.373 211.667C153.373 211.584 153.419 211.512 153.484 211.472L153.481 211.469Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M155.503 209.886C153.189 210.928 157.359 215.349 158.605 214.837C160.535 214.043 157.523 208.977 155.503 209.886Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M162.253 225.859C162.257 226.527 153.324 226.18 153.32 225.82C153.32 225.459 162.247 225.191 162.253 225.859Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M162.253 187.822C162.257 188.49 153.324 188.143 153.32 187.783C153.32 187.422 162.247 187.154 162.253 187.822Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M158.503 192.865C155.979 192.647 156.313 198.596 157.595 199.013C159.306 199.572 160.555 193.044 158.503 192.865Z",
    fill: "#FFF7E6"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M157.11 199.812C155.894 199.034 154.222 202.53 154.828 202.871C155.766 203.4 158.064 200.423 157.11 199.812Z",
    fill: "#FFF7E6"
  }))), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M26.36 67V53H28.92V58.82H35.2V53H37.76V67H35.2V60.9H28.92V67H26.36ZM41.5811 55.54C41.1144 55.54 40.7278 55.4 40.4211 55.12C40.1278 54.84 39.9811 54.4867 39.9811 54.06C39.9811 53.6333 40.1278 53.2867 40.4211 53.02C40.7278 52.74 41.1144 52.6 41.5811 52.6C42.0478 52.6 42.4278 52.74 42.7211 53.02C43.0278 53.2867 43.1811 53.6333 43.1811 54.06C43.1811 54.4867 43.0278 54.84 42.7211 55.12C42.4278 55.4 42.0478 55.54 41.5811 55.54ZM40.3011 67V57.08H42.8611V67H40.3011ZM49.5131 64.04C49.0331 64.04 48.5865 63.9867 48.1731 63.88L47.4331 64.62C47.6598 64.74 47.9665 64.84 48.3531 64.92C48.7398 65 49.3665 65.08 50.2331 65.16C51.5531 65.28 52.5131 65.5933 53.1131 66.1C53.7131 66.6067 54.0131 67.3067 54.0131 68.2C54.0131 68.7867 53.8531 69.34 53.5331 69.86C53.2131 70.3933 52.7198 70.82 52.0531 71.14C51.3865 71.4733 50.5331 71.64 49.4931 71.64C48.0798 71.64 46.9398 71.3733 46.0731 70.84C45.2065 70.32 44.7731 69.5333 44.7731 68.48C44.7731 67.5867 45.2065 66.8133 46.0731 66.16C45.8065 66.04 45.5731 65.9133 45.3731 65.78C45.1865 65.6467 45.0198 65.5067 44.8731 65.36V64.9L46.6131 63.06C45.8398 62.38 45.4531 61.5067 45.4531 60.44C45.4531 59.7733 45.6131 59.1667 45.9331 58.62C46.2665 58.0733 46.7331 57.64 47.3331 57.32C47.9331 57 48.6598 56.84 49.5131 56.84C50.0731 56.84 50.5931 56.92 51.0731 57.08H54.8331V58.64L53.1331 58.76C53.3998 59.2667 53.5331 59.8267 53.5331 60.44C53.5331 61.1067 53.3731 61.7133 53.0531 62.26C52.7331 62.8067 52.2665 63.24 51.6531 63.56C51.0531 63.88 50.3398 64.04 49.5131 64.04ZM49.5131 62.08C50.0331 62.08 50.4598 61.94 50.7931 61.66C51.1398 61.38 51.3131 60.98 51.3131 60.46C51.3131 59.94 51.1398 59.54 50.7931 59.26C50.4598 58.98 50.0331 58.84 49.5131 58.84C48.9665 58.84 48.5265 58.98 48.1931 59.26C47.8598 59.54 47.6931 59.94 47.6931 60.46C47.6931 60.98 47.8598 61.38 48.1931 61.66C48.5265 61.94 48.9665 62.08 49.5131 62.08ZM47.1131 68.22C47.1131 68.7133 47.3398 69.08 47.7931 69.32C48.2598 69.5733 48.8265 69.7 49.4931 69.7C50.1331 69.7 50.6531 69.5667 51.0531 69.3C51.4531 69.0467 51.6531 68.7 51.6531 68.26C51.6531 67.9 51.5198 67.6 51.2531 67.36C50.9998 67.12 50.4865 66.9733 49.7131 66.92C49.1665 66.88 48.6598 66.82 48.1931 66.74C47.8065 66.9533 47.5265 67.1867 47.3531 67.44C47.1931 67.6933 47.1131 67.9533 47.1131 68.22ZM56.4798 67V52.6H59.0398V58.6C59.3732 58.0533 59.8198 57.6267 60.3798 57.32C60.9532 57 61.6065 56.84 62.3398 56.84C63.5665 56.84 64.5132 57.2267 65.1798 58C65.8598 58.7733 66.1998 59.9067 66.1998 61.4V67H63.6598V61.64C63.6598 60.7867 63.4865 60.1333 63.1398 59.68C62.8065 59.2267 62.2732 59 61.5398 59C60.8198 59 60.2198 59.2533 59.7398 59.76C59.2732 60.2667 59.0398 60.9733 59.0398 61.88V67H56.4798ZM79.5934 67.24C78.1934 67.24 76.9668 66.9333 75.9134 66.32C74.8734 65.7067 74.0534 64.86 73.4534 63.78C72.8668 62.6867 72.5734 61.4267 72.5734 60C72.5734 58.5733 72.8668 57.32 73.4534 56.24C74.0534 55.1467 74.8734 54.2933 75.9134 53.68C76.9668 53.0667 78.1934 52.76 79.5934 52.76C80.9801 52.76 82.2001 53.0667 83.2534 53.68C84.3068 54.2933 85.1268 55.1467 85.7134 56.24C86.3001 57.32 86.5934 58.5733 86.5934 60C86.5934 61.3333 86.3334 62.5267 85.8134 63.58C85.2934 64.62 84.5734 65.4467 83.6534 66.06L86.8934 69.54H83.7134L81.5134 67.02C80.9001 67.1667 80.2601 67.24 79.5934 67.24ZM79.5934 64.94C80.9268 64.94 81.9868 64.5 82.7734 63.62C83.5734 62.74 83.9734 61.5333 83.9734 60C83.9734 58.4667 83.5734 57.26 82.7734 56.38C81.9868 55.5 80.9268 55.06 79.5934 55.06C78.2601 55.06 77.1934 55.5 76.3934 56.38C75.5934 57.26 75.1934 58.4667 75.1934 60C75.1934 61.5333 75.5934 62.74 76.3934 63.62C77.1934 64.5 78.2601 64.94 79.5934 64.94ZM92.45 67.24C91.21 67.24 90.25 66.8533 89.57 66.08C88.9033 65.3067 88.57 64.1733 88.57 62.68V57.08H91.11V62.44C91.11 63.2933 91.2833 63.9467 91.63 64.4C91.9767 64.8533 92.5233 65.08 93.27 65.08C93.9767 65.08 94.5567 64.8267 95.01 64.32C95.4767 63.8133 95.71 63.1067 95.71 62.2V57.08H98.27V67H96.01L95.81 65.32C95.5033 65.9067 95.0567 66.3733 94.47 66.72C93.8967 67.0667 93.2233 67.24 92.45 67.24ZM104.098 67.24C103.245 67.24 102.545 67.1067 101.998 66.84C101.451 66.56 101.045 66.1933 100.778 65.74C100.511 65.2867 100.378 64.7867 100.378 64.24C100.378 63.32 100.738 62.5733 101.458 62C102.178 61.4267 103.258 61.14 104.698 61.14H107.218V60.9C107.218 60.22 107.025 59.72 106.638 59.4C106.251 59.08 105.771 58.92 105.198 58.92C104.678 58.92 104.225 59.0467 103.838 59.3C103.451 59.54 103.211 59.9 103.118 60.38H100.618C100.685 59.66 100.925 59.0333 101.338 58.5C101.765 57.9667 102.311 57.56 102.978 57.28C103.645 56.9867 104.391 56.84 105.218 56.84C106.631 56.84 107.745 57.1933 108.558 57.9C109.371 58.6067 109.778 59.6067 109.778 60.9V67H107.598L107.358 65.4C107.065 65.9333 106.651 66.3733 106.118 66.72C105.598 67.0667 104.925 67.24 104.098 67.24ZM104.678 65.24C105.411 65.24 105.978 65 106.378 64.52C106.791 64.04 107.051 63.4467 107.158 62.74H104.978C104.298 62.74 103.811 62.8667 103.518 63.12C103.225 63.36 103.078 63.66 103.078 64.02C103.078 64.4067 103.225 64.7067 103.518 64.92C103.811 65.1333 104.198 65.24 104.678 65.24ZM112.001 67V52.6H114.561V67H112.001ZM118.337 55.54C117.87 55.54 117.483 55.4 117.177 55.12C116.883 54.84 116.737 54.4867 116.737 54.06C116.737 53.6333 116.883 53.2867 117.177 53.02C117.483 52.74 117.87 52.6 118.337 52.6C118.803 52.6 119.183 52.74 119.477 53.02C119.783 53.2867 119.937 53.6333 119.937 54.06C119.937 54.4867 119.783 54.84 119.477 55.12C119.183 55.4 118.803 55.54 118.337 55.54ZM117.057 67V57.08H119.617V67H117.057ZM126.489 67C125.449 67 124.615 66.7467 123.989 66.24C123.362 65.7333 123.049 64.8333 123.049 63.54V59.22H121.349V57.08H123.049L123.349 54.42H125.609V57.08H128.289V59.22H125.609V63.56C125.609 64.04 125.709 64.3733 125.909 64.56C126.122 64.7333 126.482 64.82 126.989 64.82H128.229V67H126.489ZM131.507 71.4L133.807 66.34H133.207L129.347 57.08H132.127L134.907 64.06L137.807 57.08H140.527L134.227 71.4H131.507ZM32.7 93.24C31.2867 93.24 30.0733 92.94 29.06 92.34C28.0467 91.7267 27.2667 90.88 26.72 89.8C26.1733 88.7067 25.9 87.4467 25.9 86.02C25.9 84.5933 26.1733 83.3333 26.72 82.24C27.2667 81.1467 28.0467 80.2933 29.06 79.68C30.0733 79.0667 31.2867 78.76 32.7 78.76C34.38 78.76 35.7533 79.18 36.82 80.02C37.9 80.8467 38.5733 82.0133 38.84 83.52H36.02C35.8467 82.76 35.4733 82.1667 34.9 81.74C34.34 81.3 33.5933 81.08 32.66 81.08C31.3667 81.08 30.3533 81.52 29.62 82.4C28.8867 83.28 28.52 84.4867 28.52 86.02C28.52 87.5533 28.8867 88.76 29.62 89.64C30.3533 90.5067 31.3667 90.94 32.66 90.94C33.5933 90.94 34.34 90.74 34.9 90.34C35.4733 89.9267 35.8467 89.36 36.02 88.64H38.84C38.5733 90.08 37.9 91.2067 36.82 92.02C35.7533 92.8333 34.38 93.24 32.7 93.24ZM44.5461 93.24C43.3061 93.24 42.3461 92.8533 41.6661 92.08C40.9994 91.3067 40.6661 90.1733 40.6661 88.68V83.08H43.2061V88.44C43.2061 89.2933 43.3794 89.9467 43.7261 90.4C44.0728 90.8533 44.6194 91.08 45.3661 91.08C46.0728 91.08 46.6528 90.8267 47.1061 90.32C47.5728 89.8133 47.8061 89.1067 47.8061 88.2V83.08H50.3661V93H48.1061L47.9061 91.32C47.5994 91.9067 47.1528 92.3733 46.5661 92.72C45.9928 93.0667 45.3194 93.24 44.5461 93.24ZM52.7741 93V83.08H55.0541L55.2941 84.94C55.6541 84.3 56.1407 83.7933 56.7541 83.42C57.3807 83.0333 58.1141 82.84 58.9541 82.84V85.54H58.2341C57.6741 85.54 57.1741 85.6267 56.7341 85.8C56.2941 85.9733 55.9474 86.2733 55.6941 86.7C55.4541 87.1267 55.3341 87.72 55.3341 88.48V93H52.7741ZM60.4838 93V83.08H62.7638L63.0038 84.94C63.3638 84.3 63.8504 83.7933 64.4638 83.42C65.0904 83.0333 65.8238 82.84 66.6638 82.84V85.54H65.9438C65.3838 85.54 64.8838 85.6267 64.4438 85.8C64.0038 85.9733 63.6571 86.2733 63.4038 86.7C63.1638 87.1267 63.0438 87.72 63.0438 88.48V93H60.4838ZM69.5734 81.54C69.1068 81.54 68.7201 81.4 68.4134 81.12C68.1201 80.84 67.9734 80.4867 67.9734 80.06C67.9734 79.6333 68.1201 79.2867 68.4134 79.02C68.7201 78.74 69.1068 78.6 69.5734 78.6C70.0401 78.6 70.4201 78.74 70.7134 79.02C71.0201 79.2867 71.1734 79.6333 71.1734 80.06C71.1734 80.4867 71.0201 80.84 70.7134 81.12C70.4201 81.4 70.0401 81.54 69.5734 81.54ZM68.2934 93V83.08H70.8534V93H68.2934ZM78.1655 93.24C77.1521 93.24 76.2588 93.02 75.4855 92.58C74.7121 92.14 74.0988 91.5267 73.6455 90.74C73.2055 89.9533 72.9855 89.0533 72.9855 88.04C72.9855 87.0267 73.2055 86.1267 73.6455 85.34C74.0988 84.5533 74.7121 83.94 75.4855 83.5C76.2588 83.06 77.1521 82.84 78.1655 82.84C79.4321 82.84 80.4988 83.1733 81.3655 83.84C82.2321 84.4933 82.7855 85.4 83.0255 86.56H80.3255C80.1921 86.08 79.9255 85.7067 79.5255 85.44C79.1388 85.16 78.6788 85.02 78.1455 85.02C77.4388 85.02 76.8388 85.2867 76.3455 85.82C75.8521 86.3533 75.6055 87.0933 75.6055 88.04C75.6055 88.9867 75.8521 89.7267 76.3455 90.26C76.8388 90.7933 77.4388 91.06 78.1455 91.06C78.6788 91.06 79.1388 90.9267 79.5255 90.66C79.9255 90.3933 80.1921 90.0133 80.3255 89.52H83.0255C82.7855 90.64 82.2321 91.54 81.3655 92.22C80.4988 92.9 79.4321 93.24 78.1655 93.24ZM88.7977 93.24C87.5577 93.24 86.5977 92.8533 85.9177 92.08C85.251 91.3067 84.9177 90.1733 84.9177 88.68V83.08H87.4577V88.44C87.4577 89.2933 87.631 89.9467 87.9777 90.4C88.3243 90.8533 88.871 91.08 89.6177 91.08C90.3243 91.08 90.9043 90.8267 91.3577 90.32C91.8243 89.8133 92.0577 89.1067 92.0577 88.2V83.08H94.6177V93H92.3577L92.1577 91.32C91.851 91.9067 91.4043 92.3733 90.8177 92.72C90.2443 93.0667 89.571 93.24 88.7977 93.24ZM97.0256 93V78.6H99.5856V93H97.0256ZM105.701 93.24C104.461 93.24 103.501 92.8533 102.821 92.08C102.155 91.3067 101.821 90.1733 101.821 88.68V83.08H104.361V88.44C104.361 89.2933 104.535 89.9467 104.881 90.4C105.228 90.8533 105.775 91.08 106.521 91.08C107.228 91.08 107.808 90.8267 108.261 90.32C108.728 89.8133 108.961 89.1067 108.961 88.2V83.08H111.521V93H109.261L109.061 91.32C108.755 91.9067 108.308 92.3733 107.721 92.72C107.148 93.0667 106.475 93.24 105.701 93.24ZM113.929 93V83.08H116.189L116.409 84.42C116.729 83.94 117.149 83.56 117.669 83.28C118.203 82.9867 118.816 82.84 119.509 82.84C121.043 82.84 122.129 83.4333 122.769 84.62C123.129 84.0733 123.609 83.64 124.209 83.32C124.823 83 125.489 82.84 126.209 82.84C127.503 82.84 128.496 83.2267 129.189 84C129.883 84.7733 130.229 85.9067 130.229 87.4V93H127.669V87.64C127.669 86.7867 127.503 86.1333 127.169 85.68C126.849 85.2267 126.349 85 125.669 85C124.976 85 124.416 85.2533 123.989 85.76C123.576 86.2667 123.369 86.9733 123.369 87.88V93H120.809V87.64C120.809 86.7867 120.643 86.1333 120.309 85.68C119.976 85.2267 119.463 85 118.769 85C118.089 85 117.536 85.2533 117.109 85.76C116.696 86.2667 116.489 86.9733 116.489 87.88V93H113.929ZM141.525 93.22C140.499 93.22 139.605 93.0467 138.845 92.7C138.085 92.34 137.492 91.84 137.065 91.2C136.652 90.56 136.445 89.8133 136.445 88.96C136.445 88.0533 136.699 87.2333 137.205 86.5C137.712 85.7667 138.465 85.18 139.465 84.74C139.065 84.2733 138.779 83.8333 138.605 83.42C138.432 83.0067 138.345 82.5667 138.345 82.1C138.345 81.46 138.505 80.8933 138.825 80.4C139.145 79.8933 139.599 79.4933 140.185 79.2C140.785 78.9067 141.499 78.76 142.325 78.76C143.165 78.76 143.879 78.9133 144.465 79.22C145.052 79.5267 145.492 79.94 145.785 80.46C146.092 80.98 146.232 81.56 146.205 82.2H143.765C143.765 81.7067 143.619 81.34 143.325 81.1C143.045 80.8467 142.705 80.72 142.305 80.72C141.852 80.72 141.485 80.8467 141.205 81.1C140.939 81.3533 140.805 81.68 140.805 82.08C140.805 82.4133 140.912 82.7533 141.125 83.1C141.339 83.4467 141.652 83.8467 142.065 84.3L145.985 88.18C146.265 87.7267 146.559 87.2 146.865 86.6L147.305 85.72H149.925L149.225 87.08C148.692 88.16 148.159 89.0733 147.625 89.82L150.845 93H147.785L146.225 91.44C145.545 92.0667 144.819 92.52 144.045 92.8C143.285 93.08 142.445 93.22 141.525 93.22ZM138.925 88.8C138.925 89.4533 139.165 90.0067 139.645 90.46C140.139 90.9 140.792 91.12 141.605 91.12C142.765 91.12 143.772 90.7067 144.625 89.88L140.925 86.22C140.245 86.5133 139.739 86.88 139.405 87.32C139.085 87.76 138.925 88.2533 138.925 88.8ZM26.36 119V105H31.54C32.66 105 33.5867 105.187 34.32 105.56C35.0533 105.933 35.6 106.447 35.96 107.1C36.32 107.753 36.5 108.487 36.5 109.3C36.5 110.073 36.3267 110.787 35.98 111.44C35.6333 112.08 35.0933 112.6 34.36 113C33.6267 113.387 32.6867 113.58 31.54 113.58H28.92V119H26.36ZM28.92 111.5H31.38C32.2733 111.5 32.9133 111.307 33.3 110.92C33.7 110.52 33.9 109.98 33.9 109.3C33.9 108.607 33.7 108.067 33.3 107.68C32.9133 107.28 32.2733 107.08 31.38 107.08H28.92V111.5ZM42.5406 119.24C41.5406 119.24 40.654 119.027 39.8806 118.6C39.1073 118.173 38.5006 117.573 38.0606 116.8C37.6206 116.027 37.4006 115.133 37.4006 114.12C37.4006 113.093 37.614 112.18 38.0406 111.38C38.4806 110.58 39.0806 109.96 39.8406 109.52C40.614 109.067 41.5206 108.84 42.5606 108.84C43.534 108.84 44.394 109.053 45.1406 109.48C45.8873 109.907 46.4673 110.493 46.8806 111.24C47.3073 111.973 47.5206 112.793 47.5206 113.7C47.5206 113.847 47.514 114 47.5006 114.16C47.5006 114.32 47.494 114.487 47.4806 114.66H39.9406C39.994 115.433 40.2606 116.04 40.7406 116.48C41.234 116.92 41.8273 117.14 42.5206 117.14C43.0406 117.14 43.474 117.027 43.8206 116.8C44.1806 116.56 44.4473 116.253 44.6206 115.88H47.2206C47.034 116.507 46.7206 117.08 46.2806 117.6C45.854 118.107 45.3206 118.507 44.6806 118.8C44.054 119.093 43.3406 119.24 42.5406 119.24ZM42.5606 110.92C41.934 110.92 41.3806 111.1 40.9006 111.46C40.4206 111.807 40.114 112.34 39.9806 113.06H44.9206C44.8806 112.407 44.6406 111.887 44.2006 111.5C43.7606 111.113 43.214 110.92 42.5606 110.92ZM54.0137 119.24C53.0804 119.24 52.2471 119.013 51.5137 118.56C50.7804 118.107 50.2004 117.487 49.7737 116.7C49.3471 115.913 49.1337 115.02 49.1337 114.02C49.1337 113.02 49.3471 112.133 49.7737 111.36C50.2004 110.573 50.7804 109.96 51.5137 109.52C52.2471 109.067 53.0804 108.84 54.0137 108.84C54.7604 108.84 55.4137 108.98 55.9738 109.26C56.5338 109.54 56.9871 109.933 57.3337 110.44V104.6H59.8937V119H57.6137L57.3337 117.58C57.0138 118.02 56.5871 118.407 56.0537 118.74C55.5337 119.073 54.8537 119.24 54.0137 119.24ZM54.5537 117C55.3804 117 56.0538 116.727 56.5738 116.18C57.1071 115.62 57.3737 114.907 57.3737 114.04C57.3737 113.173 57.1071 112.467 56.5738 111.92C56.0538 111.36 55.3804 111.08 54.5537 111.08C53.7404 111.08 53.0671 111.353 52.5337 111.9C52.0004 112.447 51.7337 113.153 51.7337 114.02C51.7337 114.887 52.0004 115.6 52.5337 116.16C53.0671 116.72 53.7404 117 54.5537 117ZM65.7006 119.24C64.8473 119.24 64.1473 119.107 63.6006 118.84C63.054 118.56 62.6473 118.193 62.3806 117.74C62.114 117.287 61.9806 116.787 61.9806 116.24C61.9806 115.32 62.3406 114.573 63.0606 114C63.7806 113.427 64.8606 113.14 66.3006 113.14H68.8206V112.9C68.8206 112.22 68.6273 111.72 68.2406 111.4C67.854 111.08 67.374 110.92 66.8006 110.92C66.2806 110.92 65.8273 111.047 65.4406 111.3C65.054 111.54 64.814 111.9 64.7206 112.38H62.2206C62.2873 111.66 62.5273 111.033 62.9406 110.5C63.3673 109.967 63.914 109.56 64.5806 109.28C65.2473 108.987 65.994 108.84 66.8206 108.84C68.234 108.84 69.3473 109.193 70.1606 109.9C70.974 110.607 71.3806 111.607 71.3806 112.9V119H69.2006L68.9606 117.4C68.6673 117.933 68.254 118.373 67.7206 118.72C67.2006 119.067 66.5273 119.24 65.7006 119.24ZM66.2806 117.24C67.014 117.24 67.5806 117 67.9806 116.52C68.394 116.04 68.654 115.447 68.7606 114.74H66.5806C65.9006 114.74 65.414 114.867 65.1206 115.12C64.8273 115.36 64.6806 115.66 64.6806 116.02C64.6806 116.407 64.8273 116.707 65.1206 116.92C65.414 117.133 65.8006 117.24 66.2806 117.24ZM77.8036 116.04C77.3236 116.04 76.8769 115.987 76.4636 115.88L75.7236 116.62C75.9503 116.74 76.2569 116.84 76.6436 116.92C77.0303 117 77.6569 117.08 78.5236 117.16C79.8436 117.28 80.8036 117.593 81.4036 118.1C82.0036 118.607 82.3036 119.307 82.3036 120.2C82.3036 120.787 82.1436 121.34 81.8236 121.86C81.5036 122.393 81.0103 122.82 80.3436 123.14C79.6769 123.473 78.8236 123.64 77.7836 123.64C76.3703 123.64 75.2303 123.373 74.3636 122.84C73.4969 122.32 73.0636 121.533 73.0636 120.48C73.0636 119.587 73.4969 118.813 74.3636 118.16C74.0969 118.04 73.8636 117.913 73.6636 117.78C73.4769 117.647 73.3103 117.507 73.1636 117.36V116.9L74.9036 115.06C74.1303 114.38 73.7436 113.507 73.7436 112.44C73.7436 111.773 73.9036 111.167 74.2236 110.62C74.5569 110.073 75.0236 109.64 75.6236 109.32C76.2236 109 76.9503 108.84 77.8036 108.84C78.3636 108.84 78.8836 108.92 79.3636 109.08H83.1236V110.64L81.4236 110.76C81.6903 111.267 81.8236 111.827 81.8236 112.44C81.8236 113.107 81.6636 113.713 81.3436 114.26C81.0236 114.807 80.5569 115.24 79.9436 115.56C79.3436 115.88 78.6303 116.04 77.8036 116.04ZM77.8036 114.08C78.3236 114.08 78.7503 113.94 79.0836 113.66C79.4303 113.38 79.6036 112.98 79.6036 112.46C79.6036 111.94 79.4303 111.54 79.0836 111.26C78.7503 110.98 78.3236 110.84 77.8036 110.84C77.2569 110.84 76.8169 110.98 76.4836 111.26C76.1503 111.54 75.9836 111.94 75.9836 112.46C75.9836 112.98 76.1503 113.38 76.4836 113.66C76.8169 113.94 77.2569 114.08 77.8036 114.08ZM75.4036 120.22C75.4036 120.713 75.6303 121.08 76.0836 121.32C76.5503 121.573 77.1169 121.7 77.7836 121.7C78.4236 121.7 78.9436 121.567 79.3436 121.3C79.7436 121.047 79.9436 120.7 79.9436 120.26C79.9436 119.9 79.8103 119.6 79.5436 119.36C79.2903 119.12 78.7769 118.973 78.0036 118.92C77.4569 118.88 76.9503 118.82 76.4836 118.74C76.0969 118.953 75.8169 119.187 75.6436 119.44C75.4836 119.693 75.4036 119.953 75.4036 120.22ZM89.1397 119.24C88.1797 119.24 87.313 119.02 86.5397 118.58C85.7797 118.14 85.173 117.533 84.7197 116.76C84.2797 115.973 84.0597 115.067 84.0597 114.04C84.0597 113.013 84.2864 112.113 84.7397 111.34C85.193 110.553 85.7997 109.94 86.5597 109.5C87.333 109.06 88.1997 108.84 89.1597 108.84C90.1064 108.84 90.9597 109.06 91.7197 109.5C92.493 109.94 93.0997 110.553 93.5397 111.34C93.993 112.113 94.2197 113.013 94.2197 114.04C94.2197 115.067 93.993 115.973 93.5397 116.76C93.0997 117.533 92.493 118.14 91.7197 118.58C90.9464 119.02 90.0864 119.24 89.1397 119.24ZM89.1397 117.02C89.8064 117.02 90.3864 116.773 90.8797 116.28C91.373 115.773 91.6197 115.027 91.6197 114.04C91.6197 113.053 91.373 112.313 90.8797 111.82C90.3864 111.313 89.813 111.06 89.1597 111.06C88.4797 111.06 87.893 111.313 87.3997 111.82C86.9197 112.313 86.6797 113.053 86.6797 114.04C86.6797 115.027 86.9197 115.773 87.3997 116.28C87.893 116.773 88.473 117.02 89.1397 117.02ZM99.8636 116.04C99.3836 116.04 98.9369 115.987 98.5236 115.88L97.7836 116.62C98.0103 116.74 98.3169 116.84 98.7036 116.92C99.0903 117 99.7169 117.08 100.584 117.16C101.904 117.28 102.864 117.593 103.464 118.1C104.064 118.607 104.364 119.307 104.364 120.2C104.364 120.787 104.204 121.34 103.884 121.86C103.564 122.393 103.07 122.82 102.404 123.14C101.737 123.473 100.884 123.64 99.8436 123.64C98.4303 123.64 97.2903 123.373 96.4236 122.84C95.5569 122.32 95.1236 121.533 95.1236 120.48C95.1236 119.587 95.5569 118.813 96.4236 118.16C96.1569 118.04 95.9236 117.913 95.7236 117.78C95.5369 117.647 95.3703 117.507 95.2236 117.36V116.9L96.9636 115.06C96.1903 114.38 95.8036 113.507 95.8036 112.44C95.8036 111.773 95.9636 111.167 96.2836 110.62C96.6169 110.073 97.0836 109.64 97.6836 109.32C98.2836 109 99.0103 108.84 99.8636 108.84C100.424 108.84 100.944 108.92 101.424 109.08H105.184V110.64L103.484 110.76C103.75 111.267 103.884 111.827 103.884 112.44C103.884 113.107 103.724 113.713 103.404 114.26C103.084 114.807 102.617 115.24 102.004 115.56C101.404 115.88 100.69 116.04 99.8636 116.04ZM99.8636 114.08C100.384 114.08 100.81 113.94 101.144 113.66C101.49 113.38 101.664 112.98 101.664 112.46C101.664 111.94 101.49 111.54 101.144 111.26C100.81 110.98 100.384 110.84 99.8636 110.84C99.3169 110.84 98.8769 110.98 98.5436 111.26C98.2103 111.54 98.0436 111.94 98.0436 112.46C98.0436 112.98 98.2103 113.38 98.5436 113.66C98.8769 113.94 99.3169 114.08 99.8636 114.08ZM97.4636 120.22C97.4636 120.713 97.6903 121.08 98.1436 121.32C98.6103 121.573 99.1769 121.7 99.8436 121.7C100.484 121.7 101.004 121.567 101.404 121.3C101.804 121.047 102.004 120.7 102.004 120.26C102.004 119.9 101.87 119.6 101.604 119.36C101.35 119.12 100.837 118.973 100.064 118.92C99.5169 118.88 99.0103 118.82 98.5436 118.74C98.1569 118.953 97.8769 119.187 97.7036 119.44C97.5436 119.693 97.4636 119.953 97.4636 120.22ZM108.07 123.4L110.37 118.34H109.77L105.91 109.08H108.69L111.47 116.06L114.37 109.08H117.09L110.79 123.4H108.07Z",
    fill: "#FFB900"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10752_2775)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 132,
    width: 38,
    height: 22,
    rx: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 132,
    width: 38,
    height: 22,
    rx: 11,
    fill: "url(#paint43_linear_10752_2775)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 132,
    width: 38,
    height: 22,
    rx: 11,
    fill: "url(#paint44_linear_10752_2775)"
  }))), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3624 146.851C46.1258 146.613 46.1258 146.228 46.3624 145.989L48.7109 143.612H39.5053C39.1715 143.612 38.8985 143.337 38.8985 143.001C38.8985 142.665 39.1715 142.39 39.5053 142.39H48.7109L46.3564 140.019C46.1197 139.781 46.1197 139.396 46.3564 139.157C46.593 138.919 46.9753 138.919 47.212 139.157L50.6102 142.573C50.8469 142.812 50.8469 143.197 50.6102 143.435L47.2181 146.851C46.9814 147.083 46.593 147.083 46.3624 146.851Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5452 26.0649L58.7162 25.6792L57.7233 22.5811L59.7707 21.907L59.3903 20.7196L56.1719 21.7804L57.5452 26.0658V26.0649ZM49.8767 18.2796L50.2571 17.0922L53.3124 18.099L54.3053 15L55.4764 15.3857L54.103 19.6712L49.8767 18.2786V18.2796ZM57.1676 26.2549L56.171 26.9895L54.283 24.3537L49.7667 27.223L46.4401 29.5477L49.8497 24.3528L51.5559 21.5828L48.9565 19.6684L49.6809 18.6577L53.276 21.3067L50.0604 25.8758L54.5543 22.6085L57.1667 26.254L57.1676 26.2549Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0572 15.467H58.0524C58.3452 15.467 58.6109 15.5039 58.8505 15.5786C59.0901 15.6523 59.2934 15.761 59.4621 15.9019C59.6309 16.0437 59.7605 16.2177 59.8509 16.4247C59.9413 16.6318 59.987 16.8653 59.987 17.1262V17.1394C59.987 17.4183 59.9367 17.6632 59.8379 17.874C59.7381 18.0858 59.5992 18.2626 59.422 18.4063C59.2449 18.55 59.0332 18.6577 58.7871 18.7296C58.541 18.8014 58.2743 18.8374 57.9862 18.8374H57.3476V20.1864H56.0572V15.467ZM57.9592 17.8135C58.1895 17.8135 58.3703 17.7587 58.5009 17.6471C58.6314 17.5365 58.6967 17.3862 58.6967 17.1962V17.1829C58.6967 16.9797 58.6314 16.8246 58.5009 16.7187C58.3703 16.6128 58.1867 16.559 57.9527 16.559H57.3476V17.8135H57.9592Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M25 29.7481H29.2477C29.8705 29.7481 30.4374 29.8266 30.9474 29.9854C31.4574 30.1433 31.8909 30.3731 32.2499 30.6746C32.6088 30.9762 32.8848 31.3478 33.0778 31.7874C33.2708 32.2279 33.3678 32.7252 33.3678 33.2801V33.3085C33.3678 33.9022 33.2615 34.4241 33.0489 34.8731C32.8363 35.3231 32.5417 35.7013 32.1641 36.0076C31.7865 36.3139 31.3362 36.5436 30.8122 36.6968C30.2882 36.8499 29.7195 36.9265 29.106 36.9265H27.7467V39.7986H25V29.7472V29.7481ZM29.0501 34.7446C29.5405 34.7446 29.9256 34.6264 30.2043 34.391C30.4831 34.1556 30.622 33.8351 30.622 33.4305V33.4011C30.622 32.9682 30.4822 32.6382 30.2043 32.4123C29.9256 32.1863 29.5368 32.0729 29.0361 32.0729H27.7476V34.7436H29.0501V34.7446Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5295 29.7481H39.2163C39.9809 29.7481 40.6279 29.8436 41.1565 30.0355C41.6852 30.2275 42.115 30.495 42.445 30.8391C43.0305 31.4139 43.3233 32.1939 43.3233 33.1799V33.2083C43.3233 33.9835 43.1396 34.6254 42.7714 35.1322C42.4031 35.6398 41.908 36.0275 41.2843 36.295L43.6487 39.7986H40.4769L38.4807 36.7545H37.2771V39.7986H34.5304V29.7472L34.5295 29.7481ZM39.0895 34.5725C39.5613 34.5725 39.9249 34.4647 40.1794 34.2492C40.434 34.0336 40.5617 33.7443 40.5617 33.3804V33.352C40.5617 32.9502 40.4293 32.6505 40.1655 32.4548C39.9007 32.2591 39.538 32.1608 39.0756 32.1608H37.2771V34.5734H39.0895V34.5725Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6949 40C48.9304 40 48.2218 39.8639 47.571 39.5906C46.9203 39.3174 46.3581 38.9468 45.8863 38.4779C45.4145 38.009 45.0435 37.4588 44.775 36.8263C44.5055 36.1948 44.3712 35.5198 44.3712 34.8022V34.7739C44.3712 34.0563 44.5055 33.3785 44.775 32.7422C45.0444 32.106 45.4192 31.5501 45.9003 31.0764C46.3814 30.6028 46.9482 30.2294 47.5999 29.9561C48.2516 29.6829 48.9593 29.5468 49.7238 29.5468C50.4883 29.5468 51.1969 29.6829 51.8477 29.9561C52.4994 30.2294 53.0607 30.5999 53.5324 31.0689C54.0042 31.5378 54.3753 32.088 54.6438 32.7205C54.9123 33.3529 55.0475 34.027 55.0475 34.7446V34.7729C55.0475 35.4905 54.9132 36.1683 54.6438 36.8046C54.3743 37.4418 53.9995 37.9967 53.5184 38.4704C53.0374 38.944 52.4705 39.3174 51.8188 39.5906C51.1671 39.8639 50.4594 40 49.6949 40ZM49.7164 37.4871C50.0949 37.4871 50.4408 37.4153 50.7531 37.2716C51.0655 37.1279 51.3302 36.9341 51.5484 36.6902C51.7656 36.4463 51.9363 36.1617 52.0593 35.8355C52.1824 35.5103 52.2439 35.1653 52.2439 34.8022V34.7739C52.2439 34.4099 52.1824 34.0658 52.0593 33.7396C51.9363 33.4144 51.761 33.127 51.5344 32.8783C51.3069 32.6297 51.0375 32.4312 50.7252 32.2827C50.4128 32.1343 50.0669 32.0606 49.6884 32.0606C49.3099 32.0606 48.9668 32.1324 48.6591 32.2761C48.3514 32.4198 48.0866 32.6136 47.8638 32.8575C47.641 33.1015 47.4713 33.387 47.3529 33.7122C47.2345 34.0374 47.1757 34.3825 47.1757 34.7455V34.7739C47.1757 35.1378 47.2373 35.482 47.3603 35.8072C47.4834 36.1324 47.6559 36.4198 47.8787 36.6684C48.1006 36.9171 48.3682 37.1156 48.6805 37.264C48.9929 37.4125 49.3388 37.4862 49.7173 37.4862L49.7164 37.4871Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4777 29.7481H60.7254C61.3482 29.7481 61.9151 29.8266 62.4251 29.9854C62.9351 30.1443 63.3686 30.3731 63.7276 30.6746C64.0865 30.9762 64.3625 31.3478 64.5555 31.7874C64.7485 32.2279 64.8455 32.7252 64.8455 33.2801V33.3085C64.8455 33.9022 64.7392 34.4241 64.5266 34.8731C64.314 35.3231 64.0194 35.7013 63.6418 36.0076C63.2642 36.3139 62.8139 36.5436 62.2899 36.6968C61.7659 36.8499 61.1972 36.9265 60.5837 36.9265H59.2244V39.7986H56.4777V29.7472V29.7481ZM60.5278 34.7446C61.0182 34.7446 61.4033 34.6264 61.682 34.391C61.9608 34.1556 62.0997 33.8351 62.0997 33.4305V33.4011C62.0997 32.9682 61.9599 32.6382 61.682 32.4123C61.4033 32.1863 61.0135 32.0729 60.5138 32.0729H59.2253V34.7436H60.5278V34.7446Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0081 29.7481H73.9665V32.1173H68.7128V33.6394H73.4705V35.8365H68.7128V37.4304H74.0374V39.7996H66.0081V29.7481Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4527 29.7481H78.1994V37.3586H83V39.7996H75.4527V29.7481Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10752_2775",
    x: 0,
    y: 0,
    width: 189,
    height: 230,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10752_2775"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10752_2775",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10752_2775",
    x: 18,
    y: 124,
    width: 54,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10752_2775"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10752_2775",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10752_2775",
    x1: 79.6996,
    y1: 157.114,
    x2: 79.6996,
    y2: 207.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10752_2775",
    x1: 65.9472,
    y1: 156.176,
    x2: 65.9472,
    y2: 206.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10752_2775",
    x1: 72.6664,
    y1: 167.887,
    x2: 72.6664,
    y2: 215.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10752_2775",
    x1: 85.2219,
    y1: 171.093,
    x2: 85.2219,
    y2: 215.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10752_2775",
    x1: 60.2832,
    y1: 176.448,
    x2: 60.2832,
    y2: 213.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10752_2775",
    x1: 72.7485,
    y1: 205.784,
    x2: 72.7485,
    y2: 224.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10752_2775",
    x1: 177.702,
    y1: 172.398,
    x2: 130.563,
    y2: 172.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10752_2775",
    x1: 152.006,
    y1: 218.158,
    x2: 152.006,
    y2: 202.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10752_2775",
    x1: 152.006,
    y1: 141.712,
    x2: 152.006,
    y2: 198.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67C8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#499EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3581A7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_10752_2775",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.799 164.543) rotate(180) scale(35.053 35.3618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_10752_2775",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.799 164.544) rotate(180) scale(35.053 35.3618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_10752_2775",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.799 164.545) rotate(180) scale(35.053 35.3618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_10752_2775",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.799 164.544) rotate(180) scale(35.0529 35.3618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_10752_2775",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.799 164.545) rotate(180) scale(35.053 35.3618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10752_2775",
    x1: 175.356,
    y1: 220.18,
    x2: 128.656,
    y2: 220.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10752_2775",
    x1: 186.029,
    y1: 175.268,
    x2: 127.928,
    y2: 175.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10752_2775",
    x1: 84.3999,
    y1: 194.539,
    x2: 84.4978,
    y2: 227.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10752_2775",
    x1: 181.313,
    y1: 220.431,
    x2: 182.969,
    y2: 226.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10752_2775",
    x1: 182.68,
    y1: 220.247,
    x2: 182.7,
    y2: 226.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10752_2775",
    x1: 181.317,
    y1: 220.429,
    x2: 182.973,
    y2: 226.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10752_2775",
    x1: 173.529,
    y1: 152.236,
    x2: 173.746,
    y2: 224.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10752_2775",
    x1: 146.006,
    y1: 219.149,
    x2: 142.657,
    y2: 230.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10752_2775",
    x1: 145.072,
    y1: 222.452,
    x2: 142.607,
    y2: 231.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10752_2775",
    x1: 153.86,
    y1: 152.295,
    x2: 154.077,
    y2: 224.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10752_2775",
    x1: 164.184,
    y1: 145.965,
    x2: 164.219,
    y2: 157.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10752_2775",
    x1: 164.201,
    y1: 152.266,
    x2: 164.418,
    y2: 224.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10752_2775",
    x1: 164.21,
    y1: 155.107,
    x2: 164.233,
    y2: 162.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10752_2775",
    x1: 148.219,
    y1: 193.633,
    x2: 148.318,
    y2: 226.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10752_2775",
    x1: 144.528,
    y1: 193.643,
    x2: 144.627,
    y2: 226.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10752_2775",
    x1: 166.583,
    y1: 193.578,
    x2: 166.682,
    y2: 226.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10752_2775",
    x1: 121.607,
    y1: 195.564,
    x2: 121.644,
    y2: 207.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10752_2775",
    x1: 104.872,
    y1: 195.614,
    x2: 104.909,
    y2: 207.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10752_2775",
    x1: 121.585,
    y1: 188.267,
    x2: 121.608,
    y2: 195.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10752_2775",
    x1: 107.935,
    y1: 188.309,
    x2: 107.958,
    y2: 195.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10752_2775",
    x1: 121.641,
    y1: 207.312,
    x2: 121.7,
    y2: 227.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10752_2775",
    x1: 153.628,
    y1: 186.225,
    x2: 153.628,
    y2: 227.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10752_2775",
    x1: 153.628,
    y1: 187.33,
    x2: 153.628,
    y2: 226.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10752_2775",
    x1: 153.628,
    y1: 186.226,
    x2: 153.628,
    y2: 227.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10752_2775",
    x1: 153.628,
    y1: 186.225,
    x2: 153.628,
    y2: 227.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10752_2775",
    x1: 153.628,
    y1: 186.226,
    x2: 153.628,
    y2: 227.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_10752_2775",
    x1: 153.628,
    y1: 186.225,
    x2: 153.628,
    y2: 227.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_10752_2775",
    x1: 153.586,
    y1: 195.623,
    x2: 153.586,
    y2: 207.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_10752_2775",
    x1: 153.635,
    y1: 216.28,
    x2: 153.635,
    y2: 223.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_10752_2775",
    x1: 64,
    y1: 154,
    x2: 24.0901,
    y2: 149.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_10752_2775",
    x1: 45,
    y1: 100.604,
    x2: 45,
    y2: 154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDA44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10752_2775"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 185,
    height: 226,
    rx: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpShort);
export default __webpack_public_path__ + "static/media/CP_Short.8f178a6086500a01560ed83817c8bae1.svg";
export { ForwardRef as ReactComponent };